import {
  Component,
  DestroyRef,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {BenutzerDTO} from 'src/app/models/benutzer/BenutzerDTO';
import {TranslateService} from '@ngx-translate/core';
import {SchuleService} from '../../../@core/services/schule/schule.service';
import {SchuljahrService} from '../../../@core/services/schuljahr/schuljahr.service';
import {SchuelerService} from '../../../@core/services/schueler/schueler.service';
import {Wegtyp} from '../../../models/antrag-ticket/Wegtyp';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators,} from '@angular/forms';
import {AntragTicketDTO} from '../../../models/antrag-ticket/AntragTicketDTO';
import {AntragTicketSonderfallDto} from '../../../models/antrag-ticket/AntragTicketSonderfallDto';
import {TicketAntragStatus} from '../../../models/antrag-ticket/TicketAntragStatus';
import {AntragTicketService} from 'src/app/@core/services/antrag-ticket/antrag-ticket.service';
import {CustomToastService} from '../../../@core/utils/custom-toast.service';
import {FieldConfigService} from 'src/app/@core/services/field-config/field-config.service';
import {Land} from '../../../models/land/Land';
import {catchError, pairwise, startWith, switchMap, tap,} from 'rxjs/operators';
import {EMPTY, forkJoin, Observable, of, Subscription} from 'rxjs';
import {HaltestelleService} from '../../../@core/services/haltestelle/haltestelle.service';
import {Pagination, PaginationService,} from '../../../@core/utils/pagination.service';
import {HaltestellenPageDTO} from '../../../models/haltestelle/HaltestellenPageDTO';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {SchuelerDTO} from '../../../models/schueler/SchuelerDTO';
import {AntragTicketUpdateDTO} from '../../../models/antrag-ticket/AntragTicketUpdateDTO';
import {AntragTicketSepaUpdateDTO} from '../../../models/antrag-ticket/AntragTicketSepaUpdateDTO';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons';
import {Router} from '@angular/router';
import {TextbausteinService} from '../../../@core/services/textbaustein/textbaustein.service';
import {TicketDetailParentComponent} from '../ticket-detail-parent/ticket-detail-parent.component';
import {ConfirmComponent} from '../../../shared/confirm/confirm.component';
import {ValidatorService} from 'angular-iban';
import {ModuleConfigService} from '../../../@core/services/module-config/module-config.service';
import {PlzValidationHelperService} from '../../../@core/utils/forms/plz-validation-helper.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {
  createDateIsBetweenValidator,
  createVormundAgeValidator,
  DateTimeHelperService,
} from '../../../@core/utils/forms/datetime-helper.service';
import {TicketDTO} from '../../../models/ticket/TicketDTO';
import {toTitlecase} from '../../../@core/utils/forms/string-helper';
import {PostleitzahlenService} from '../../../@core/services/postleitzahlen/postleitzahlen.service';
import {SessionService} from '../../../@core/services/session/session.service';
import {
  SecureSessionStorageService
} from '../../../@core/services/secure-session-storage/secure-session-storage.service';
import {KeyString} from '../../../models/textbaustein/KeyString';
import {ValidationHelperService} from '../../../@core/utils/forms/validation-helper.service';
import {ConfigService} from 'src/app/@core/config/services/config.service';
import {MANDATORY_UPLOAD_MARKER, PFLICHTFELDMARKER,} from '../../../../assets/constants/constants';
import {
  HaltestelleDisplayComboNameService
} from '../../../@core/services/haltestelle/haltestelle-display-comboname.service';
import {AttachmentType, getSelectableAttachmentTypes,} from '../../../models/antrag-ticket/AttachmentType';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {SchoolLevel} from '../../../models/schule/SchoolLevel';
import {SchoolType} from '../../../models/schule/SchoolType';
import {computeVertragsbeginnRange} from './vertragsbeginn-range';
import {
  TicketAntragSidebarAttachmentsComponent
} from './sidebar/ticket-antrag-sidebar-attachments/ticket-antrag-sidebar-attachments.component';
import {SchoolInfoComponent} from './school-info/school-info.component';
import {GeneralConfigService} from '../../../@core/services/config/general-config/general-config.service';
import {ExportConfigDto} from '../../../models/config/export/ExportConfigDto';
import {AntragTicketSchoolInfoService} from '../../../@core/services/antrag-ticket/antrag-ticket-school-info.service';
import {AntragTicketSchoolInfoUpdateDto} from '../../../models/antrag-ticket/AntragTicketSchoolInfoUpdateDto';
import {
  VertragsbeginnConstraintsService
} from '../../../@core/services/antrag-ticket/vertragsbeginn-constraints.service';
import {parseISO} from 'date-fns';

@Component({
  selector: 'app-ticket-detail-sb-true',
  templateUrl: './ticket-detail-sb-true.component.html',
  styleUrls: ['./ticket-detail-sb-true.component.scss'],
  standalone: false,
})
export class TicketDetailSbTrueComponent
  implements OnInit, OnDestroy, OnChanges
{
  @ViewChild('bezugNachweis')
  bezugNachweis: TicketAntragSidebarAttachmentsComponent;
  @ViewChild('praktikumsvertrag')
  praktikumsvertrag: TicketAntragSidebarAttachmentsComponent;
  @ViewChild('schoolInfoComponent') schoolInfoComponent: SchoolInfoComponent;

  readonly destroyRef = inject(DestroyRef);
  readonly dateTimeHelperService = inject(DateTimeHelperService);
  faInfo = faInfoCircle;

  @Input() antragTicketId: string | null;
  @Input() benutzer: BenutzerDTO;
  @Input() benutzerRoles: string[];
  @Input() fieldConfig;
  @Input() optionErmaessigung = [];
  @Input() optionGeschlecht = [];
  @Input() optionWegtyp = [];
  @Input() optionSonderfall = [];
  @Input() optionSchoolType = [];
  @Input() landList = [];

  @Input() requiredFields: string[] = [];
  @Input() visibleFields: string[] = [];

  @Input() antragTicketFormFields = [];
  @Input() antragTicketSepaFormFields = [];
  @Input() antragTicketGeschwister1FormFields = [];
  @Input() antragTicketGeschwister2FormFields = [];
  @Input() antragTicketGeschwister3FormFields = [];
  @Input() antragTicketGeschwister4FormFields = [];
  @Input() antragTicketGeschwister5FormFields = [];

  @Input() schulwegOnOff = [];
  @Input() praktikumOnOff = [];
  @Input() beidesOnOff = [];
  @Input() schuleOnOff = [];
  @Input() berufskollegOnOff = [];
  @Input() schuljahrOnOff = [];
  @Input() vormundOnOff = [];
  @Input() vormundAdresseAbweichendOnOff;
  @Input() asylOnOff = [];
  @Input() sepaMandatgeberNotAntragst = [];
  @Input() sepaMandatgeberYesAntragst = [];

  selectableAttachmentTypes = getSelectableAttachmentTypes();

  pflichtFeldMarker = PFLICHTFELDMARKER;

  schuleList = [];
  schuljahreList = [];
  filteredSchuljahreList = [];
  filteredKlassenList = [];
  filteredBildungsgangList = [];
  filteredTicketList: TicketDTO[] = [];
  schuelerList = [];

  antragTicket: AntragTicketDTO;
  antragTicketForm: UntypedFormGroup;

  draftStatus = TicketAntragStatus.ENTWURF;
  eingereichtStatus = TicketAntragStatus.EINGEREICHT;
  wegtypPRAKTIKUMSWEG = Wegtyp.PRAKTIKUMSWEG;

  readonly = false;
  schuelerDeleted = false;

  isSchuelerUnderAge = false;
  isAntragstellerYoungerThanMinimumAge = false;
  isAntragstellerUnderage = false;

  today: string;
  minDate: string;
  maxDate: string;
  minDatePraktikumEnddatum: string;
  maxDateVormundGeburtsdatum: string;
  minDateBirthday: string;
  minDateTicketGueltigAb: Date | null = null;
  maxDateTicketGueltigAb: Date | null = null;
  gueltigAbInfoText: string;
  gueltigAbNoteText: string;

  //haltestellen
  einstiegHaltestelleList = [];
  einstiegHaltestellePage: HaltestellenPageDTO;
  einstiegHaltestellePagination: Pagination = {
    ...this.paginationService.getDefaultPagination('name', 1000),
  };
  einstiegHaltestelleLoading = false;

  ausstiegHaltestelleList = [];

  //buttons
  isDeleteDraftButtonVisible = false;
  isUpdateEntwurfButtonVisible = false;
  isEinreichenButtonVisible = false;
  isCopyButtonVisible = false;
  isVormundCheckboxChecked = false;

  //subscriptions
  formItemSubscriptions: Subscription[] = [];

  allVormundFieldsInvisible = false;

  //validators
  effectiveValidators: string[] = [];
  effectivelyVisible: string[] = [];
  isInitializing = true;
  isSubmitted = false;
  isMonthSelection = false;

  // disable checkboxes if readonly == true
  disableCheckboxes: string[] = [
    'bezugAsylbewerberleistungsgesetz',
    'sonderfallEnabled',
    'einverstaendnisErklaerung',
    'richtigkeitDerAngaben',
    'isAntragstellerNotMandatsgeber',
    'datenschutz',
    'marketingfreigabe',
    'vertragsbedingungen',
    'angabenKorrekt',
    'tarifbestimmungenZugestimmt',
  ];
  disableGueltigAb = true;
  private constraintsLoadFailed = false;

  existsSessionStorageTextbausteine = false;
  earliestVertragsbeginn: Date | null = null;
  antragstellerFristTag: number | null = null;

  filteredSchoolLevelList: SchoolLevel[] = [];

  vormundFields = [
    'vormundName',
    'vormundVorname',
    'isVormundadresseAbweichend',
    'vormundStrasse',
    'vormundOrt',
    'vormundPlz',
    'vormundAdresszusatz',
    'vormundLand',
    'vormundGeburtsdatum',
    'vormundTelefonnummer',
    'vormundEmail',
    'vormundGeschlecht',
  ];

  isAllContentHidden = false;

  listsInitialized = false;

  exportConfig: ExportConfigDto;

  allowedWegtypen: Wegtyp[] = [];
  geschwisterEigenanteilKomponenteEnabled = true;

  ticketartPlaceholder = '-';

  MODULE_ANTRAG_TICKET_SONDERFALL = 'antragTicketSonderfall';
  /**
   * field_config(module='antragTicket', field='sonderfall').visible — the pre-existing master
   * on/off switch for the whole Sonderfall feature (already hides the Sonderfall section in both
   * frontends; see ticket-detail templates). Reused here as an AND-gate so that when the whole
   * feature is switched off, no per-Sonderfall Nachweis is ever mandatory either — regardless of
   * the individual antragTicketSonderfall.&lt;TYPE&gt;.required flags.
   */
  FIELD_CONFIG_ANTRAG_TICKET_SONDERFALL_FEATURE_SWITCH = 'sonderfall';

  constructor(
    public translateService: TranslateService,
    private readonly schuleService: SchuleService,
    private readonly schuljahrService: SchuljahrService,
    private readonly schuelerService: SchuelerService,
    private readonly fb: UntypedFormBuilder,
    private readonly antragTicketService: AntragTicketService,
    private readonly customToastService: CustomToastService,
    private readonly router: Router,
    public fieldConfigService: FieldConfigService,
    public moduleConfigService: ModuleConfigService,
    private readonly haltestelleService: HaltestelleService,
    private readonly paginationService: PaginationService,
    private readonly modalService: NgbModal,
    public textbausteinService: TextbausteinService,
    private readonly parent: TicketDetailParentComponent,
    private readonly plzHelper: PlzValidationHelperService,
    private readonly spinner: NgxSpinnerService,
    private readonly datetimeHelper: DateTimeHelperService,
    private readonly postleitzahlenService: PostleitzahlenService,
    private readonly sessionService: SessionService,
    private readonly validationHelper: ValidationHelperService,
    private readonly configService: ConfigService,
    private readonly haltestelleDisplayComboNameService: HaltestelleDisplayComboNameService,
    private readonly generalConfigService: GeneralConfigService,
    private readonly antragTicketSchoolInfoService: AntragTicketSchoolInfoService,
    private readonly secureSessionStorageService: SecureSessionStorageService,
    private readonly vertragsbeginnConstraintsService: VertragsbeginnConstraintsService,
  ) {
    // Ensure the form exists immediately so unit/component tests can patch values synchronously
    // (tests may access component.antragTicketForm before ngOnInit async initialization completes).
    try {
      this.initEmptyForm();
    } catch (e) {
      // ignore if FormBuilder not yet available in some test harnesses
    }
  }

  showSpinner(): void {
    this.isAllContentHidden = true;
    try {
      this.spinner.show().catch((e) => {
        console.log('Spinner error', e);
      });
    } catch (e) {
      // ignore spinner errors in test harnesses
    }
  }

  hideSpinner(): void {
    this.isAllContentHidden = false;
    try {
      this.spinner.hide().catch((e) => {
        console.log('Spinner error', e);
      });
    } catch (e) {
      // ignore spinner errors in test harnesses
    }
  }

  ngOnInit(): void {
    this.showSpinner();

    this.vertragsbeginnConstraintsService
      .getConstraints()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (constraints) => {
          this.earliestVertragsbeginn = parseISO(
            constraints.earliestVertragsbeginn,
          );
          this.antragstellerFristTag = constraints.antragstellerFristTag;
          if (this.schoolInfoComponent?.getSchoolYearId()) {
            this.schuljahrChange(false);
          }
        },
        () => {
          this.constraintsLoadFailed = true;
          this.disableGueltigAb = true;
          this.gueltigAbInfoText = this.translateService.instant(
            'TICKETDETAIL.ABO_GUELTIG_AB_INFO_KONFIGURATION_FEHLT',
          );
        },
      );

    this.sessionService
      .watchSessionStorageExistsTextbausteine()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((yesNo) => {
        this.existsSessionStorageTextbausteine = yesNo;
      });

    this.effectivelyVisible = [...this.visibleFields];
    this.effectiveValidators = [...this.requiredFields];

    this.makeInit()
      .then(() => {
        this.hideSpinner();

        this.adjustSubtitle();
        this.isInitializing = false;

        this.checkAntragstellerAge();
        this.adjustVormundFieldsByAgeOfAntragstellerAndValuesSet();
        if (this.allVormundFieldsInvisible === false) {
          this.calcAllVormundFieldsInvisible();
        }
      })
      .catch(() => {
        this.hideSpinner();
      });
  }

  makeInit(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.isInitializing = true;

      this.initEmptyForm();
      this.setDateMinMax();
      this.initAboDatumGueltigAb();
      this.loadExportConfig();
      this.loadAntragConfig();
      this.loadEigenanteilConfig();

      let listsObservable: Observable<any>;
      try {
        listsObservable = this.initListsForSBtrue();
      } catch (err) {
        // Defensive: if initListsForSBtrue throws (eg in test environment with incomplete stubs)
        // ensure initialization completes so hideSpinner() is called by caller.
        this.listsInitialized = true;
        this.createSubscriptions();
        resolve(true);
        return;
      }
      if (!listsObservable || typeof listsObservable.subscribe !== 'function') {
        this.listsInitialized = true;
        this.createSubscriptions();
        resolve(true);
        return;
      }
      listsObservable.subscribe({
        complete: () => {
          this.listsInitialized = true;
          this.createSubscriptions();
          if (this.antragTicketId) {
            this.antragTicketService.setAntragID$.next(
              this.antragTicketId.toString(),
            );

            this.antragTicketService.antragObs$
              .pipe(
                takeUntilDestroyed(this.destroyRef),
                catchError(() => {
                  this.customToastService.showError(
                    this.translateService.instant(
                      'TICKETDETAIL.ERROR.ANTRAG_LOAD_FAILED',
                    ),
                  );
                  resolve(true);
                  return EMPTY;
                }),
              )
              .subscribe((data: AntragTicketDTO) => {
                if (!data) {
                  return;
                }
                this.antragTicket = { ...data };
                this.autoPatchForm(
                  this.antragTicket,
                  this.antragTicketFormFields,
                );
                this.populateSonderfaelleFormArray(
                  this.antragTicket.sonderfaelle,
                );
                this.sonderfaelleChange();
                this.updateFieldVisibilityBySchoolType();
                if (this.antragTicket?.antragTicketSepa) {
                  this.autoPatchForm(
                    this.antragTicket?.antragTicketSepa,
                    this.antragTicketSepaFormFields,
                  );

                  if (
                    this.antragTicket?.antragTicketSepa
                      ?.isAntragstellerMandatsgeber == undefined
                  ) {
                    this.antragTicketForm.patchValue({
                      isAntragstellerNotMandatsgeber: false,
                    });
                  } else {
                    this.antragTicketForm.patchValue({
                      isAntragstellerNotMandatsgeber:
                        !this.antragTicket?.antragTicketSepa
                          ?.isAntragstellerMandatsgeber,
                    });
                  }
                }
                if (this.isMonthSelection) {
                  //remove first day from Month from  ('2022-08-01') to ('2022-08')
                  this.antragTicketForm.patchValue({
                    aboGueltigkeit: this.antragTicket?.aboGueltigkeit
                      ?.toString()
                      .slice(0, 7),
                  });
                }
                if (this.antragTicket.geschwisterkind1) {
                  this.autoPatchForm(
                    this.antragTicket.geschwisterkind1,
                    this.antragTicketGeschwister1FormFields,
                  );
                  this.setGeschwisterkind(1);
                }
                if (this.antragTicket.geschwisterkind2) {
                  this.autoPatchForm(
                    this.antragTicket.geschwisterkind2,
                    this.antragTicketGeschwister2FormFields,
                  );
                  this.setGeschwisterkind(2);
                }
                if (this.antragTicket.geschwisterkind3) {
                  this.autoPatchForm(
                    this.antragTicket.geschwisterkind3,
                    this.antragTicketGeschwister3FormFields,
                  );
                  this.setGeschwisterkind(3);
                }
                if (this.antragTicket.geschwisterkind4) {
                  this.autoPatchForm(
                    this.antragTicket.geschwisterkind4,
                    this.antragTicketGeschwister4FormFields,
                  );
                  this.setGeschwisterkind(4);
                }
                if (this.antragTicket.geschwisterkind5) {
                  this.autoPatchForm(
                    this.antragTicket.geschwisterkind5,
                    this.antragTicketGeschwister5FormFields,
                  );
                  this.setGeschwisterkind(5);
                }

                this.readonly =
                  this.antragTicket.status != TicketAntragStatus.ENTWURF;
                this.schuelerDeleted =
                  this.antragTicket.schueler?.deleted || false;
                if (this.schuelerDeleted) {
                  this.customToastService.showWarning(
                    this.readonly
                      ? this.translateService.instant(
                          'TICKETDETAIL.WARN.SCHUELER_DELETED',
                        )
                      : this.translateService.instant(
                          'TICKETDETAIL.WARN.SCHUELER_DELETED',
                        ) +
                          this.translateService.instant(
                            'TICKETDETAIL.WARN.VALID_SCHUELER_REQUIRED',
                          ),
                  );
                }
                if (!this.readonly) {
                  this.correctLand();
                  this.updateSchuelerFields();
                }
                this.importCopiedAntragFromSessionStorage().then(() => {
                  this.setButtonVisibility();
                  this.disableCheckboxesFunc();
                  resolve(true);
                });
              });
          } else {
            this.setButtonVisibility();
            this.sonderfaelleChange();
            this.updateFieldVisibilityBySchoolType();
            this.disableCheckboxesFunc();
            this.updateSchuelerFields();
            resolve(true);
          }
        },
        error: (error) => {
          console.log(error);
          this.hideSpinner();
        },
      });
    });
  }

  filterWegtypOptions() {
    this.optionWegtyp = [{ id: null, name: '-' }];

    if (this.onlySchulwegAllowed()) {
      this.optionWegtyp = [
        {
          id: 'SCHULWEG',
          name: this.translateService.instant('TICKETDETAIL.WEGTYP.SCHULWEG'),
        },
      ];
      this.getFormItem('wegtyp')?.patchValue(Wegtyp.SCHULWEG);
      this.wegtypChange();
      return;
    }

    for (const wegtyp of this.allowedWegtypen) {
      if (!this.optionWegtyp.map((it) => it.id).includes(wegtyp)) {
        this.optionWegtyp.push({
          id: wegtyp,
          name: this.translateService.instant('TICKETDETAIL.WEGTYP.' + wegtyp),
        });
      }
    }
  }

  onlySchulwegAllowed(): boolean {
    return (
      this.allowedWegtypen?.length === 1 &&
      this.allowedWegtypen[0] === Wegtyp.SCHULWEG
    );
  }

  updateSchuelerFields(): void {
    const schuelerId = this.getFormItem('schueler')?.value;
    if (schuelerId) {
      this.schuelerService
        .getSchueler(schuelerId)
        .pipe(
          catchError(() => {
            this.customToastService.showWarning(
              this.translateService.instant('TICKETDETAIL.UPDATE_SCHUELER'),
            );
            return EMPTY;
          }),
        )
        .subscribe((schueler) => {
          this.antragTicketForm?.patchValue({
            name: schueler?.name,
            vorname: schueler?.vorname,
            geburtsdatum: schueler?.geburtsdatum,
            geschlecht: schueler?.geschlecht,
            // Patch address fields as well to keep address/PLZ validation consistent when switching Schüler.
            plz: schueler?.plz,
            ort: schueler?.ort,
            strasse: schueler?.strasse,
            adresszusatz: schueler?.adresszusatz,
            land:
              typeof schueler?.land === 'string' &&
              schueler.land.trim().length > 0
                ? schueler.land.trim().toUpperCase()
                : 'DEUTSCHLAND',
          });
        });
    }
  }

  private checkAntragstellerAge() {
    if (!this.benutzer) return;
    this.isAntragstellerYoungerThanMinimumAge =
      this.datetimeHelper.isYoungerThan(
        this.benutzer?.geburtsdatum?.toString(),
        this.configService.featureConfig.minimumAge,
      );
    this.isAntragstellerUnderage = this.datetimeHelper.isYoungerThan(
      this.benutzer?.geburtsdatum?.toString(),
      18,
    );
    if (this.isAntragstellerUnderage !== true) {
      const idx = this.effectivelyVisible.indexOf(
        'zustimmungGesetzlicherVertreter',
      );
      if (idx != -1) this.effectivelyVisible.splice(idx, 1);
    }
  }

  private adjustVormundFieldsByAgeOfAntragstellerAndValuesSet() {
    if (
      this.isAntragstellerYoungerThanMinimumAge ||
      this.isOneVormundValueSet()
    ) {
      this.isVormundCheckboxChecked = true;
    }
  }

  isOneVormundValueSet(): boolean {
    const antrag = this.antragTicket;
    return !!(
      antrag?.vormundVorname ||
      antrag?.vormundName ||
      antrag?.vormundGeburtsdatum ||
      antrag?.vormundStrasse ||
      antrag?.vormundPlz ||
      antrag?.vormundOrt ||
      antrag?.vormundTelefonnummer ||
      antrag?.vormundEmail ||
      antrag?.vormundGeschlecht ||
      antrag?.vormundAdresszusatz ||
      antrag?.isVormundadresseAbweichend === true
    );
  }

  toggleVormundByCheckbox() {
    if (this.isVormundCheckboxChecked) {
      this.updateEffectivelyVisible(this.vormundFields, []);
      this.isVormundadresseAbweichendChanged();
    } else {
      this.updateEffectivelyVisible([], this.vormundFields);
    }
  }

  private calcAllVormundFieldsInvisible() {
    this.allVormundFieldsInvisible = true;
    for (const vormundField of this.vormundFields) {
      if (
        this.fieldConfigService.getFieldFromFieldConfig(
          vormundField,
          this.fieldConfig,
        )?.visible
      ) {
        this.allVormundFieldsInvisible = false;
        break;
      }
    }
  }

  setDateMinMax() {
    this.minDate = DateTimeHelperService.CALENDAR_MINIMUM;
    this.minDateBirthday = DateTimeHelperService.BIRTHDATE_MINIMUM;
    this.today = this.datetimeHelper.formattedToday();
    this.maxDate = DateTimeHelperService.CALENDAR_MAXIMUM;
    this.maxDateVormundGeburtsdatum = this.datetimeHelper.maxDateVormund();
  }

  rebuildOptionsSonderfall() {
    this.optionSonderfall = [
      {
        value: null,
        name: this.getFieldLabelOrTranslate(
          'NICHT_AUSGEWAEHLT',
          'TICKETDETAIL.SONDERFALL.NICHT_AUSGEWAEHLT',
        ),
        info: '',
      },
      {
        value: 'SCHWERBEHINDERUNG',
        name: this.getSonderfallOptionLabel(
          'SCHWERBEHINDERUNG',
          'TICKETDETAIL.SONDERFALL.SCHWERBEHINDERUNG',
        ),
        info: '',
      },
      {
        value: 'INKLUSION_BESONDERE_FOERDERUNG',
        name: this.getSonderfallOptionLabel(
          'INKLUSION_BESONDERE_FOERDERUNG',
          'TICKETDETAIL.SONDERFALL.INKLUSION_BESONDERE_FOERDERUNG',
        ),
        info: '',
      },
      {
        value: 'ERKRANKUNG_VERLETZUNG',
        name: this.getSonderfallOptionLabel(
          'ERKRANKUNG_VERLETZUNG',
          'TICKETDETAIL.SONDERFALL.ERKRANKUNG_VERLETZUNG',
        ),
        info: this.textbausteinService.printTextbausteinByKey(
          KeyString.SONDERFALL_ERKRANKUNG_VERLETZUNG_INFO,
          '',
        ),
      },
      {
        value: 'ZUWEISUNG_DES_KOMMUNALEN_INTEGRATIONSZENTRUMS',
        name: this.getSonderfallOptionLabel(
          'ZUWEISUNG_DES_KOMMUNALEN_INTEGRATIONSZENTRUMS',
          'TICKETDETAIL.SONDERFALL.ZUWEISUNG_DES_KOMMUNALEN_INTEGRATIONSZENTRUMS',
        ),
        info: '',
      },
      {
        value: 'SCHULEMPFEHLUNG_DES_KOMMUNALEN_INTEGRATIONSZENTRUMS',
        name: this.getSonderfallOptionLabel(
          'SCHULEMPFEHLUNG_DES_KOMMUNALEN_INTEGRATIONSZENTRUMS',
          'TICKETDETAIL.SONDERFALL.SCHULEMPFEHLUNG_DES_KOMMUNALEN_INTEGRATIONSZENTRUMS',
        ),
        info: '',
      },
      {
        value: 'GYMNASIUM_MIT_GEWAEHLTEM_BILINGUALEN_BILDUNGSGANG',
        name: this.getSonderfallOptionLabel(
          'GYMNASIUM_MIT_GEWAEHLTEM_BILINGUALEN_BILDUNGSGANG',
          'TICKETDETAIL.SONDERFALL.GYMNASIUM_MIT_GEWAEHLTEM_BILINGUALEN_BILDUNGSGANG',
        ),
        info: '',
      },
      {
        value: 'SPORTKLASSE_NRW',
        name: this.getSonderfallOptionLabel(
          'SPORTKLASSE_NRW',
          'TICKETDETAIL.SONDERFALL.SPORTKLASSE_NRW',
        ),
        info: '',
      },
      {
        value: 'AUSZUBILDENDE_VON_BEZIRKSFACHKLASSEN',
        name: this.getSonderfallOptionLabel(
          'AUSZUBILDENDE_VON_BEZIRKSFACHKLASSEN',
          'TICKETDETAIL.SONDERFALL.AUSZUBILDENDE_VON_BEZIRKSFACHKLASSEN',
        ),
        info: '',
      },
      {
        value: 'INTERNAT',
        name: this.getSonderfallOptionLabel(
          'INTERNAT',
          'TICKETDETAIL.SONDERFALL.INTERNAT',
        ),
        info: '',
      },
      {
        value: 'ARBEITSLOSIGKEIT_UND_BERUFSSCHULPFLICHTIGKEIT',
        name: this.getSonderfallOptionLabel(
          'ARBEITSLOSIGKEIT_UND_BERUFSSCHULPFLICHTIGKEIT',
          'TICKETDETAIL.SONDERFALL.ARBEITSLOSIGKEIT_UND_BERUFSSCHULPFLICHTIGKEIT',
        ),
        info: '',
      },
      {
        value: 'ABLEHNUNG_NAECHSTGELEGENE_SCHULE_DER_SELBEN_SCHULFORM',
        name: this.getSonderfallOptionLabel(
          'ABLEHNUNG_NAECHSTGELEGENE_SCHULE_DER_SELBEN_SCHULFORM',
          'TICKETDETAIL.SONDERFALL.ABLEHNUNG_NAECHSTGELEGENE_SCHULE_DER_SELBEN_SCHULFORM',
        ),
        info: '',
      },
      {
        value: 'WOHNSITZ_IM_AUSLAND',
        name: this.getSonderfallOptionLabel(
          'WOHNSITZ_IM_AUSLAND',
          'TICKETDETAIL.SONDERFALL.WOHNSITZ_IM_AUSLAND',
        ),
        info: this.translateService.instant(
          'TICKETDETAIL.SONDERFALL.WOHNSITZ_IM_AUSLAND_INFO',
        ),
      },
      {
        value: 'UMZUG_IM_LAUFENDEN_SCHULJAHR',
        name: this.getSonderfallOptionLabel(
          'UMZUG_IM_LAUFENDEN_SCHULJAHR',
          'TICKETDETAIL.SONDERFALL.UMZUG_IM_LAUFENDEN_SCHULJAHR',
        ),
        info: '',
      },
      {
        value: 'SONSTIGES',
        name: this.getSonderfallOptionLabel(
          'SONSTIGES',
          'TICKETDETAIL.SONDERFALL.SONSTIGES',
        ),
        info: '',
      },
    ];
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateEffectiveValidators();
    if (changes.optionSonderfall) {
      this.rebuildOptionsSonderfall();
      this.filterAntragTicketSonderfallByFieldConfig();
    }
    this.setSelectableAttachmentTypes();
  }

  setSelectableAttachmentTypes() {
    if (this.visibleFields?.length <= 0) {
      return;
    }
    const invisible: AttachmentType[] = [];
    if (!this.visibleFields.includes('sonderfallNachweis')) {
      invisible.push(AttachmentType.SONDERFALLNACHWEIS);
    }
    if (!this.visibleFields.includes('bezugNachweis')) {
      invisible.push(AttachmentType.BEZUGSNACHWEIS);
    }
    if (!this.visibleFields.includes('praktikumsvertrag')) {
      invisible.push(AttachmentType.PRAKTIKUMSNACHWEIS);
    }
    this.selectableAttachmentTypes = getSelectableAttachmentTypes().filter(
      (it) => {
        return !invisible.includes(it);
      },
    );
  }

  createSubscriptions() {
    /*
      SonarLint marks startWith as deprecated, but it's only deprecated if used with a scheduler
      startWith(null) and startWith(undefined) are ok
     */
    this.formItemSubscriptions.push(
      this.antragTicketForm
        .get('geburtsdatum')
        .valueChanges.pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (next !== prev) {
            this.vormundChange();
          }
        }),
      this.antragTicketForm
        .get('wegtyp')
        .valueChanges.pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (next !== prev) {
            this.wegtypChange();
          }
        }),
      this.antragTicketForm
        .get('isAntragstellerNotMandatsgeber')
        .valueChanges.pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (next == null || next !== prev) {
            this.sepaChange();
          }
        }),
      this.getSonderfaelleFormArray()
        .valueChanges.pipe(startWith(null))
        .subscribe(() => {
          this.sonderfaelleChange();
        }),
      this.antragTicketForm
        .get('isVormundadresseAbweichend')
        .valueChanges.pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (next == null || next !== prev) {
            this.isVormundadresseAbweichendChanged();
          }
        }),
      this.antragTicketForm
        .get('bezugAsylbewerberleistungsgesetz')
        .valueChanges.pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (next == null || next !== prev) {
            this.asylChange();
          }
        }),
      this.antragTicketForm
        .get('praktikumStartdatum')
        .valueChanges.pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (next !== prev) {
            this.praktikumDatumChange();
          }
        }),
      this.antragTicketForm
        .get('praktikumEnddatum')
        .valueChanges.pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (next !== prev) {
            this.praktikumDatumChange();
          }
        }),
      this.antragTicketForm
        .get('einstieghaltestelleId')
        .valueChanges.pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (next !== prev) {
            this.checkForHaltestellenMatch('einstieghaltestelleId');
          }
        }),
      this.antragTicketForm
        .get('ausstieghaltestelleHinwegId')
        .valueChanges.pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (next !== prev) {
            this.checkForHaltestellenMatch('ausstieghaltestelleHinwegId');
          }
        }),
      this.getFormItem('land')?.valueChanges.subscribe(() => {
        this.setPlzPatternValidator('plz', 'land');
      }),
      this.getFormItem('vormundLand')?.valueChanges.subscribe(() => {
        this.setPlzPatternValidator('vormundPlz', 'vormundLand');
      }),
      this.getFormItem('praktikumLand')?.valueChanges.subscribe(() => {
        this.setPlzPatternValidator('praktikumPlz', 'praktikumLand');
      }),
      this.getFormItem('landSepa')?.valueChanges.subscribe(() => {
        this.setPlzPatternValidator('plzSepa', 'landSepa');
      }),
    );
  }

  disableCheckboxesFunc() {
    if (this.readonly === true && !!this.antragTicketForm) {
      //programmatically disables checkboxes: safest option
      this.disableCheckboxes.forEach((cb) =>
        this.antragTicketForm.get(cb)?.disable(),
      );
    } else if (this.readonly !== true && !!this.antragTicketForm) {
      this.disableCheckboxes.forEach((cb) =>
        this.antragTicketForm.get(cb)?.enable(),
      );
    }
  }

  resetFormValues(varnames: string[]) {
    if (this.readonly || this.isInitializing || !this.antragTicketForm) return;
    varnames.forEach((varname: string) => {
      this.antragTicketForm?.get(varname)?.patchValue(null);
    });
  }

  getInfoTextbausteinOrTranslate(
    textbausteinKey: KeyString,
    translateKey: string,
  ): string {
    return this.existsSessionStorageTextbausteine
      ? this.textbausteinService.printTextbausteinByKey(
          textbausteinKey,
          translateKey ? this.translateService.instant(translateKey) : '',
        )
      : '';
  }

  adjustSubtitle() {
    if (this.readonly !== true)
      Promise.resolve(null)
        .then(
          () =>
            (this.parent.subtitle =
              this.textbausteinService.printTextbausteinByKey(
                KeyString.SUBTITLE_TEXT_TICKET,
                this.translateService.instant(
                  'TICKETDETAIL.SUBTITLE_TEXT_TICKET',
                ),
              )),
        )
        .catch(() => {});
    else
      Promise.resolve(null)
        .then(() => (this.parent.subtitle = ''))
        .catch(() => {});
  }

  updateEffectivelyVisible(add: string[], remove: string[]) {
    if (this.effectivelyVisible) {
      remove.forEach((varName) => {
        if (!add.includes(varName)) {
          while (this.effectivelyVisible.includes(varName)) {
            this.effectivelyVisible.splice(
              this.effectivelyVisible.indexOf(varName),
              1,
            );
          }
          this.resetFormValues([varName]);
        }
      });
      add.forEach((varName) => {
        if (
          !this.effectivelyVisible.includes(varName) &&
          this.visibleFields.includes(varName)
        ) {
          this.effectivelyVisible = [...this.effectivelyVisible, varName];
        }
      });
    }
    this.updateEffectiveValidators();
  }

  resetFormValidators(varnames: string[]) {
    varnames.forEach((varname: string) => {
      if (this.getFormItem(varname)) {
        this.getFormItem(varname).clearValidators();
        this.getFormItem(varname).clearAsyncValidators();
        this.getFormItem(varname).setErrors(null);
        this.getFormItem(varname).updateValueAndValidity();
      }
    });
  }

  updateEffectiveValidators() {
    if (this.effectivelyVisible.length > 0) {
      this.effectiveValidators = [];
      this.requiredFields.forEach((varName) => {
        if (this.effectivelyVisible.includes(varName))
          this.effectiveValidators = [...this.effectiveValidators, varName];
      });
      this.checkAntragstellerAge();
    }
    if (this.isSubmitted === true) this.applyValidators().catch(() => {});
    else {
      // these validators always react on bad input
      this.addFormalValidators();
    }
  }

  wegtypChange() {
    const status = this.getFormItem('wegtyp')?.value;
    if (!status) return;
    let add, remove;
    switch (status) {
      case Wegtyp.SCHULWEG: {
        add = this.schulwegOnOff;
        remove = this.beidesOnOff.concat(this.praktikumOnOff);
        break;
      }
      case Wegtyp.BEIDES: {
        add = this.schulwegOnOff
          .concat(this.praktikumOnOff)
          .concat(this.beidesOnOff);
        remove = [];
        break;
      }
      case Wegtyp.PRAKTIKUMSWEG: {
        add = this.praktikumOnOff;
        remove = this.schulwegOnOff.concat(this.beidesOnOff);
      }
    }
    this.updateEffectivelyVisible(add, remove);
  }

  schuleChange() {
    // reset lists and values that depend on schule
    if (!this.readonly && !this.isInitializing && !!this.antragTicketForm) {
      this.filteredKlassenList = [];
      this.filteredBildungsgangList = [];
      this.filteredSchuljahreList = [];
      this.ausstiegHaltestelleList = [];
      this.antragTicketForm.patchValue({
        fachbereichId: null,
        ausstieghaltestelleHinwegId: null,
        aboGueltigkeit: null,
      });
      this.schoolInfoComponent?.resetFields();
    }

    this.filterListsForSelectedSchule();

    // handle visibility and validation
    this.updateFieldVisibilityBySchoolType();
    this.getPlaceholderForTicketart();
  }

  private filterListsForSelectedSchule() {
    const schuleId = this.schoolInfoComponent?.getSchoolId();
    const schuleDto = this.schuleList?.find((x) => x.id === schuleId);
    if (schuleDto) {
      // if readonly -> not Entwurf -> show all tickets in existence for this schule (tickets)
      // if !readonly -> Entwurf -> show only ticket selection (ticketsa), and only non-archived
      this.filterTicketList();
      // similar goes for the other lists
      this.filteredSchuljahreList =
        this.schuljahreList.filter(
          (schuljahr) =>
            schuljahr.berufskolleg ===
              (schuleDto?.schoolType === SchoolType.VOCATIONAL) &&
            schuljahr['archiv'] !== true,
        ) || [];
      this.filteredKlassenList = this.readonly
        ? schuleDto.klassen
        : (schuleDto.klassen?.filter((t) => t['archiv'] !== true) ?? []);
      this.filteredBildungsgangList = this.readonly
        ? schuleDto.bildungsgaenge
        : (schuleDto.bildungsgaenge?.filter((t) => t['archiv'] !== true) ?? []);
      this.ausstiegHaltestelleList = [];
      schuleDto.haltestellen?.forEach(
        (haltestelle) =>
          (this.ausstiegHaltestelleList = this.ausstiegHaltestelleList.concat({
            id: haltestelle.id,
            name: haltestelle.name,
            tarifgebietName: haltestelle.tarifgebietName,
            comboName:
              this.haltestelleDisplayComboNameService.getComboName(haltestelle),
            archiv: haltestelle.archiv,
          })),
      );

      this.schuleService
        .getSchoolLevelsForSchule(schuleId)
        .subscribe((levels) => {
          this.filteredSchoolLevelList = levels;
        });
    }
  }

  /**
   * Fired by SchoolInfoComponent when the saved school could only be mapped after the schoolList
   * arrived late (remapSchoolIfNeeded() patches with emitEvent: false, so schoolChangeEvent is not
   * emitted). The initial updateFieldVisibilityBySchoolType() ran with an empty schoolId and thus
   * treated the school as non-Berufskolleg - re-evaluate visibility/validators and the school
   * dependent lists now, without resetting any user data (unlike schuleChange()).
   */
  onSchoolRemapped() {
    this.filterListsForSelectedSchule();
    this.updateFieldVisibilityBySchoolType();
    this.getPlaceholderForTicketart();
  }

  updateFieldVisibilityBySchoolType() {
    let add, remove;
    const schoolId = this.schoolInfoComponent?.getSchoolId();
    // An empty schoolId means the school is not known (yet) - e.g. right after loading the Antrag, before
    // SchoolInfoComponent has resolved the saved school. isBerufskolleg() returns false for an empty id, so it
    // must not be used here: treating an unknown school as 'no Berufskolleg' would drop the Berufskolleg fields
    // (bildungsgangId, bildungsgangdatum, ...) of a saved Berufskolleg from effectivelyVisible/effectiveValidators.
    const isB = schoolId ? this.isBerufskolleg(schoolId) : undefined;
    if (isB === true) {
      add = this.berufskollegOnOff;
      remove = this.schuleOnOff;
    } else if (isB === false) {
      add = this.schuleOnOff;
      remove = this.berufskollegOnOff;
    } else {
      // no school (yet): neither school nor Berufskolleg specific fields apply
      add = [];
      remove = this.schuleOnOff.concat(this.berufskollegOnOff);
    }
    this.updateEffectivelyVisible(add, remove);
  }

  /**
   * Fired once SchoolInfoComponent has (re-)loaded its data from the backend, both on a normal
   * page load and after importCopiedAntragFromSessionStorage() re-applies copied Schuldaten onto a
   * freshly created draft. Re-evaluates schuljahrChange() so disableGueltigAb/min-max validators for
   * Vertragsbeginn are recalculated from the resolved Schuljahr, independent of whether the
   * schoolYearId value-change event fired reliably for the initial patch. resetValue=false, since
   * this is not a user-driven Schuljahr change - Vertragsbeginn must stay untouched/empty here.
   * Only relevant for a new/copied (ENTWURF) draft: for a regular, already-saved Antrag this is
   * already handled by loadExistingAntrag()'s own handleAboGueltigAb() call.
   */
  onSchoolInfoInit() {
    // A copied draft can already have a real antragTicketId (createNewEntwurf() assigns one before
    // navigating here), so ENTWURF status must be checked too - same discriminator as
    // handleAboGueltigAb()/schuljahrChange() already use below.
    if (
      this.antragTicketId == null ||
      this.antragTicket?.status === TicketAntragStatus.ENTWURF
    ) {
      this.schuljahrChange(false);
    }
  }

  schuljahrChange(resetValue: boolean = true) {
    const schuljahrId = this.schoolInfoComponent?.getSchoolYearId();

    if (!schuljahrId) return;

    this.filterTicketList();
    this.getPlaceholderForTicketart();

    const selectedSchuljahr = this.schuljahreList.find(
      (schuljahr) => schuljahr.id === schuljahrId,
    );
    this.gueltigAbNoteText = '';
    const schuljahrStart = selectedSchuljahr?.start
      ? parseISO(selectedSchuljahr.start)
      : null;
    const schuljahrEnde = selectedSchuljahr?.ende
      ? parseISO(selectedSchuljahr.ende)
      : null;
    if (
      selectedSchuljahr &&
      schuljahrStart &&
      schuljahrEnde &&
      !Number.isNaN(schuljahrStart.getTime()) &&
      !Number.isNaN(schuljahrEnde.getTime())
    ) {
      this.disableGueltigAb = false;
      this.gueltigAbInfoText = '';
    } else {
      this.disableGueltigAb = true;
      this.gueltigAbInfoText = this.textbausteinService.printTextbausteinByKey(
        KeyString.ABO_GUELTIG_AB_INFO_KEIN_SCHULJAHR,
        this.translateService.instant(
          'TICKETDETAIL.ABO_GUELTIG_AB_INFO_KEIN_SCHULJAHR',
        ),
      );
      return;
    }

    if (
      this.antragTicketId == null ||
      this.antragTicket.status === TicketAntragStatus.ENTWURF
    ) {
      const todayDate = parseISO(this.today);

      const range = computeVertragsbeginnRange(
        schuljahrStart,
        schuljahrEnde,
        todayDate,
        this.antragstellerFristTag,
        this.isMonthSelection,
        this.earliestVertragsbeginn,
      );
      this.minDateTicketGueltigAb = range.minDate;
      this.maxDateTicketGueltigAb = range.maxDate;

      if (range.reason === 'current-month') {
        this.gueltigAbInfoText =
          this.textbausteinService.printTextbausteinByKey(
            KeyString.ABO_GUELTIG_AB_INFO_LAUFENDER_MONAT,
            this.translateService.instant(
              'TICKETDETAIL.ABO_GUELTIG_AB_INFO_LAUFENDER_MONAT',
            ),
          );
      } else if (range.reason === 'following-month') {
        this.gueltigAbInfoText =
          this.textbausteinService.printTextbausteinByKey(
            KeyString.ABO_GUELTIG_AB_INFO_FOLGENDER_MONAT,
            this.translateService.instant(
              'TICKETDETAIL.ABO_GUELTIG_AB_INFO_FOLGENDER_MONAT',
            ),
          );
      }

      if (this.minDateTicketGueltigAb > this.maxDateTicketGueltigAb) {
        this.gueltigAbInfoText =
          this.textbausteinService.printTextbausteinByKey(
            KeyString.ABO_GUELTIG_AB_INFO_KEIN_TICKET,
            this.translateService.instant(
              'TICKETDETAIL.ABO_GUELTIG_AB_INFO_KEIN_TICKET',
            ),
          );
        this.disableGueltigAb = true;
      }

      //get value if set
      let aboGueltigkeitValue: Date;
      if (this.isMonthSelection) {
        aboGueltigkeitValue =
          this.getFormItem('aboGueltigkeit')?.value?.length > 0
            ? new Date(
                this.getFormItem('aboGueltigkeit')?.value?.toString() + '-01',
              )
            : null;
      } else {
        aboGueltigkeitValue =
          this.getFormItem('aboGueltigkeit')?.value?.length > 0
            ? new Date(this.getFormItem('aboGueltigkeit')?.value)
            : null;
      }

      //reset Value if not in min_max range or disabled
      // let patchNewValue;
      if (!resetValue) {
        // skip auto-fill/clamp: caller only wants disableGueltigAb/min-max/validators recalculated
      } else if (this.disableGueltigAb) {
        this.antragTicketForm.patchValue({ aboGueltigkeit: undefined });
      } else if (
        aboGueltigkeitValue < this.minDateTicketGueltigAb ||
        this.maxDateTicketGueltigAb < aboGueltigkeitValue
      ) {
        const minDate = this.datetimeHelper.removeTimeZone(
          this.minDateTicketGueltigAb,
        );
        let patchValue: string;
        if (this.isMonthSelection) {
          patchValue = minDate.toISOString().slice(0, 7);
        } else {
          patchValue = minDate.toISOString().slice(0, 10);
        }
        this.antragTicketForm.patchValue({ aboGueltigkeit: patchValue });
      }

      if (this.isMonthSelection) {
        this.gueltigAbNoteText = this.translateService.instant(
          'TICKETDETAIL.INFO.ABO_DATUM_MIN_MAX',
          {
            minDate: this.datetimeHelper.formattedMonth(
              this.minDateTicketGueltigAb,
            ),
            maxDate: this.datetimeHelper.formattedMonth(
              this.maxDateTicketGueltigAb,
            ),
          },
        );
      } else {
        this.gueltigAbNoteText = '';
      }

      this.getFormItem('aboGueltigkeit')?.setValidators([
        createDateIsBetweenValidator(
          this.minDateTicketGueltigAb,
          this.maxDateTicketGueltigAb,
        ),
      ]);
      this.getFormItem('aboGueltigkeit')?.updateValueAndValidity();
    }
  }

  vormundChange() {
    if (!this.getFormItem('geburtsdatum')) return;
    const underage: boolean = this.datetimeHelper.isYoungerThan(
      this.getFormItem('geburtsdatum')?.value,
      18,
    );

    this.antragTicketForm?.patchValue({ isUnderAge: underage });
    this.isSchuelerUnderAge = underage;
    let add, remove;
    if (underage) {
      add = this.vormundOnOff;
      remove = ['emailSchueler', 'telefonnummer'];
    } else {
      add = ['emailSchueler', 'telefonnummer'];
      remove = this.vormundOnOff;
    }
    this.isVormundadresseAbweichendChanged();
    this.updateEffectivelyVisible(add, remove);
  }

  getSonderfaelleFormArray(): UntypedFormArray {
    return this.antragTicketForm?.get('sonderfaelle') as UntypedFormArray;
  }

  populateSonderfaelleFormArray(
    entries: AntragTicketSonderfallDto[],
    keepIds = true,
  ) {
    const formArray = this.getSonderfaelleFormArray();
    if (!formArray) return;
    formArray.clear();
    (entries ?? []).forEach((entry) => {
      formArray.push(
        this.fb.group({
          id: [keepIds ? entry.id : null],
          sonderfall: [entry.sonderfall],
          begruendung: [entry.begruendung],
        }),
      );
    });
  }

  sonderfaelleChange() {
    const formArray = this.getSonderfaelleFormArray();

    formArray?.controls?.forEach((group) => {
      const isSonstiges = group.get('sonderfall')?.value === 'SONSTIGES';
      const begruendung = group.get('begruendung');

      if (isSonstiges) {
        begruendung?.setValidators([Validators.required]);
      } else {
        begruendung?.clearValidators();
      }
      begruendung?.updateValueAndValidity({ emitEvent: false });
    });

    const hasSelection = formArray?.length > 0;
    this.updateEffectivelyVisible(
      hasSelection ? ['sonderfallNachweis'] : [],
      hasSelection ? [] : ['sonderfallNachweis'],
    );
  }

  asylChange() {
    let add, remove;
    if (!this.getFormItem('bezugAsylbewerberleistungsgesetz')) return;
    if (this.getFormItem('bezugAsylbewerberleistungsgesetz').value) {
      add = this.asylOnOff;
      remove = [];
    } else {
      add = [];
      remove = this.asylOnOff;
    }
    this.updateEffectivelyVisible(add, remove);
  }

  sepaChange() {
    let add, remove;
    if (!this.getFormItem('isAntragstellerNotMandatsgeber')) return;
    if (this.getFormItem('isAntragstellerNotMandatsgeber').value) {
      add = this.sepaMandatgeberNotAntragst;
      remove = this.sepaMandatgeberYesAntragst;
      this.getFormItem('iban').removeValidators([
        ValidatorService.validateIban,
      ]);
      this.getFormItem('ibanSepa').setValidators([
        ValidatorService.validateIban,
      ]);

      this.getFormItem('iban').updateValueAndValidity();
      this.getFormItem('ibanSepa').updateValueAndValidity();
    } else {
      add = this.sepaMandatgeberYesAntragst;
      remove = this.sepaMandatgeberNotAntragst;
      this.getFormItem('iban').setValidators([ValidatorService.validateIban]);
      this.getFormItem('ibanSepa').removeValidators([
        ValidatorService.validateIban,
      ]);

      this.getFormItem('iban').updateValueAndValidity();
      this.getFormItem('ibanSepa').updateValueAndValidity();
    }
    this.updateEffectivelyVisible(add, remove);
  }

  isVormundadresseAbweichendChanged() {
    let add, remove;
    if (this.getFormItem('isVormundadresseAbweichend')?.value) {
      add = this.vormundAdresseAbweichendOnOff;
      remove = [];
    } else {
      add = [];
      remove = this.vormundAdresseAbweichendOnOff;
    }
    this.updateEffectivelyVisible(add, remove);
  }

  praktikumDatumChange() {
    if (this.getFormItem('praktikumStartdatum')) {
      this.minDatePraktikumEnddatum = this.getFormItem(
        'praktikumStartdatum',
      )?.value;
      if (
        !!this.getFormItem('praktikumEnddatum') &&
        this.getFormItem('praktikumEnddatum')?.value <
          this.getFormItem('praktikumStartdatum')?.value
      ) {
        this.getFormItem('praktikumEnddatum')?.patchValue(
          this.getFormItem('praktikumStartdatum')?.value,
        );
      }
    }
  }

  isBerufskolleg(id): boolean {
    if (!id) {
      return false;
    }
    return (
      this.schuleList?.find((schule) => schule.id === id)?.schoolType ===
      SchoolType.VOCATIONAL
    );
  }

  setButtonVisibility() {
    if (!this.readonly) {
      this.isEinreichenButtonVisible = !this.schuelerDeleted;
      this.isUpdateEntwurfButtonVisible = !this.schuelerDeleted;
      this.isDeleteDraftButtonVisible = !!this.antragTicketId;
    } else {
      this.isDeleteDraftButtonVisible = false;
      this.isUpdateEntwurfButtonVisible = false;
      this.isEinreichenButtonVisible = false;
    }
    this.isCopyButtonVisible = !!this.antragTicketId;
  }

  filterTicketList() {
    const schuljahrId = this.schoolInfoComponent?.getSchoolYearId();
    const schuleId = this.schoolInfoComponent?.getSchoolId();
    const schuleDto = this.schuleList?.find((x) => x.id === schuleId);
    this.filteredTicketList = this.readonly
      ? schuleDto?.tickets
      : (schuleDto?.ticketsa?.filter((t) => t['archiv'] !== true) ?? []);
    this.filteredTicketList = this.filteredTicketList?.filter(
      (ticket: TicketDTO) =>
        ticket.schuleIds?.includes(schuleId) &&
        ticket.schuljahrIds?.includes(schuljahrId),
    );
  }

  getPlaceholderForTicketart() {
    const schuleId = this.schoolInfoComponent?.getSchoolId();
    const schuljahrId = this.schoolInfoComponent?.getSchoolYearId();
    if (!schuleId && !schuljahrId) {
      this.ticketartPlaceholder = this.translateService.instant(
        'TICKETDETAIL.TICKETART_PLACEHOLDER_SCHULJAHR_SCHULE',
      );
    } else if (!schuleId && !!schuljahrId) {
      this.ticketartPlaceholder = this.translateService.instant(
        'TICKETDETAIL.TICKETART_PLACEHOLDER_SCHULE',
      );
    } else if (!!schuleId && !schuljahrId) {
      this.ticketartPlaceholder = this.translateService.instant(
        'TICKETDETAIL.TICKETART_PLACEHOLDER_SCHULJAHR',
      );
    } else {
      this.ticketartPlaceholder = '-';
    }
  }

  autoPatchForm(source: any, fields: string[]) {
    const patchIfNotDirty = (field, value) => {
      if (!this.antragTicketForm.get(field)?.dirty) {
        this.antragTicketForm.patchValue({ [field]: value });
      }
    };
    for (const varname of fields) {
      let sourceElement = source[varname];
      if (varname.endsWith('Id')) {
        sourceElement = source[varname.replace('Id', '')];
      }
      if (sourceElement != null && typeof sourceElement == 'object') {
        //geschwisterkind, haltestelle etc.
        if (varname === 'einstieghaltestelleId') {
          const haltestelle = sourceElement;
          // make sure einstieghaltestelleList is prepopulated with einstieghaltestelleId loaded with antrag
          this.einstiegHaltestelleList = this.einstiegHaltestelleList.concat({
            id: haltestelle.id,
            name: haltestelle.name,
            tarifgebietName: haltestelle.tarifgebietName,
            comboName:
              this.haltestelleDisplayComboNameService.getComboName(haltestelle),
            archiv: haltestelle.archiv,
          });
        }
        patchIfNotDirty(varname, sourceElement?.id);
      } else if (sourceElement) {
        patchIfNotDirty(varname, sourceElement);
      }
    }
  }

  /**
   * Auto create DTO from form values
   * @param targetDTO - the DTO to be filled, ie XyzCreateDTO or XyzUpdateDTO
   * @param fields - the fields to be filled in the DTO
   */
  autoCreateDTO(targetDTO: any, fields: string[]) {
    for (const varname of fields) {
      targetDTO[varname] = this.getFormItem(varname)?.value;
    }
  }

  addSchueler() {
    this.saveOrUpdate(
      TicketAntragStatus.ENTWURF,
      this.translateService.instant('TICKETDETAIL.INFO.ENTWURF_SAVED_REDIRECT'),
      'schueler-detail',
    );
  }

  applyValidators(): Promise<any> {
    return new Promise((resolve) => {
      this.clearAllValidators();
      this.checkAntragstellerAge();
      this.effectiveValidators.forEach((varName) => {
        this.getFormItem(varName)?.setValidators([Validators.required]);
        if (
          varName === 'datenschutz' ||
          varName === 'marketingfreigabe' ||
          varName === 'richtigkeitDerAngaben' ||
          varName === 'einverstaendnisErklaerung' ||
          varName === 'zustimmungGesetzlicherVertreter' ||
          varName === 'vertragsbedingungen' ||
          varName === 'angabenKorrekt' ||
          varName === 'tarifbestimmungenZugestimmt'
        ) {
          this.getFormItem(varName)?.setValidators([
            Validators.required,
            Validators.requiredTrue,
          ]);
        } else if (varName === 'emailSchueler') {
          this.getFormItem(varName)?.setValidators([
            Validators.required,
            Validators.email,
          ]);
        } else if (varName === 'vormundEmail') {
          this.getFormItem(varName)?.setValidators([
            Validators.required,
            Validators.email,
          ]);
        } else if (varName === 'emailSepa') {
          this.getFormItem(varName)?.setValidators([
            Validators.required,
            Validators.email,
          ]);
        } else if (varName === 'plz') {
          this.setPlzPatternValidator(varName, 'land');
        } else if (varName === 'vormundPlz') {
          this.setPlzPatternValidator(varName, 'vormundLand');
        } else if (varName === 'praktikumPlz') {
          this.setPlzPatternValidator(varName, 'praktikumLand');
        } else if (varName === 'plzSepa') {
          this.setPlzPatternValidator(varName, 'landSepa');
        } else if (varName.toLowerCase().includes('iban')) {
          this.getFormItem(varName)?.setValidators([
            Validators.required,
            ValidatorService.validateIban,
          ]);
        } else if (varName === 'vormundGeburtsdatum') {
          this.getFormItem(varName)?.setValidators([
            Validators.required,
            createVormundAgeValidator(),
          ]);
        } else if (varName === 'aboGueltigkeit') {
          this.getFormItem(varName)?.setValidators([
            Validators.required,
            createDateIsBetweenValidator(
              this.minDateTicketGueltigAb,
              this.maxDateTicketGueltigAb,
            ),
          ]);
        } else if (varName === 'strasse') {
          // add validators for strasse and hausnummer
          this.getFormItem(varName)?.setValidators([
            Validators.required,
            Validators.pattern(this.validationHelper.strasseHausnummerPattern),
          ]);
        } else if (
          varName === 'telefonnummer' ||
          varName === 'vormundTelefonnummer' ||
          varName === 'telefonnummerSepa'
        ) {
          // add validators for telefonnummer
          this.getFormItem(varName)?.setValidators([
            Validators.pattern(this.validationHelper.telefonnummerPattern),
          ]);
        } else if (varName === 'bezugNachweis') {
          if (
            !this.bezugNachweis?.hasAttachmentsOfType(
              AttachmentType.BEZUGSNACHWEIS,
            )
          ) {
            this.getFormItem('bezugNachweis')?.setValidators([
              Validators.required,
            ]);
          } else {
            this.getFormItem('bezugNachweis')?.clearValidators();
          }
        } else if (varName === 'praktikumsvertrag') {
          if (
            !this.praktikumsvertrag?.hasAttachmentsOfType(
              AttachmentType.PRAKTIKUMSNACHWEIS,
            )
          ) {
            this.getFormItem('praktikumsvertrag')?.setValidators([
              Validators.required,
            ]);
          } else {
            this.getFormItem('praktikumsvertrag')?.clearValidators();
          }
        }
        this.getFormItem(varName)?.updateValueAndValidity();
      });
      // Submission-gate for SONDERFALLNACHWEIS: deliberately NOT part of effectiveValidators/the loop
      // above, because whether it applies is a per-Sonderfall-type decision (field_config module
      // 'antragTicketSonderfall'), independent of the retired global 'sonderfallNachweis.required'
      // flag that used to gate membership there.
      this.applySonderfallNachweisValidator();
      // add formal validators to validate non required fields with Regex patterns
      this.addFormalValidators();
      resolve('hurra');
    });
  }

  /**
   * Mirrors the backend's isSonderfallNachweisRequired: a missing SONDERFALLNACHWEIS attachment only
   * blocks submission for Sonderfall rows whose own type is configured as required (and the global
   * Sonderfall feature switch is on) — not for every selected Sonderfall unconditionally.
   */
  private applySonderfallNachweisValidator(): void {
    // Only a draft can still be changed; on a submitted Antrag a retroactively enabled Nachweispflicht
    // must not invalidate the form (symmetric to SBM ticket-detail.component.ts).
    if (
      this.antragTicket?.id &&
      this.antragTicket?.status !== TicketAntragStatus.ENTWURF
    ) {
      this.getFormItem('sonderfallNachweis')?.clearValidators();
      this.getFormItem('sonderfallNachweis')?.updateValueAndValidity();
      return;
    }
    const requiredTypes = this.getSonderfaelleRequiringNachweis();
    const missingRequiredNachweis =
      this.getSonderfaelleFormArray()?.controls?.some((group) => {
        const sonderfallType = group.get('sonderfall')?.value;
        if (!sonderfallType || !requiredTypes.includes(sonderfallType)) {
          return false;
        }
        const sonderfallId = group.get('id')?.value;
        return (
          !sonderfallId ||
          !this.antragTicket?.attachments?.some(
            (a) =>
              a.sonderfallId === sonderfallId &&
              a.attachmentType === AttachmentType.SONDERFALLNACHWEIS,
          )
        );
      }) ?? false;
    if (missingRequiredNachweis) {
      this.getFormItem('sonderfallNachweis')?.setValidators([
        Validators.required,
      ]);
    } else {
      this.getFormItem('sonderfallNachweis')?.clearValidators();
    }
    this.getFormItem('sonderfallNachweis')?.updateValueAndValidity();
  }

  clearAllValidators() {
    const controls = this.antragTicketForm.controls;
    for (const name in controls) {
      controls[name].clearAsyncValidators();
      controls[name].clearValidators();
      if (
        !(
          name === 'iban' ||
          name === 'ibanSepa' ||
          name === 'vormundGeburtsdatum'
        )
      )
        controls[name].setErrors(null);
    }
  }

  updateAntragTicket(
    targetStatus: TicketAntragStatus,
    saveMsg: string,
    goToPath: string,
  ) {
    this.saveUpdate(targetStatus)
      .then((result) => {
        if (result) {
          if (goToPath == 'ticket-detail')
            goToPath += '/' + this.antragTicket.id;
          this.router
            .navigate(['pages/' + goToPath])
            .then(() => {
              this.customToastService.showSuccess(saveMsg);
            })
            .catch(() => {});
        } else {
          this.hideSpinner();
        }
      })
      .catch(() => {
        this.hideSpinner();
      });
  }

  saveUpdate(targetStatus): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const antragTicketUpdateDTOtemp: AntragTicketUpdateDTO =
        {} as AntragTicketUpdateDTO;
      this.autoCreateDTO(
        antragTicketUpdateDTOtemp,
        this.antragTicketFormFields,
      );
      antragTicketUpdateDTOtemp.sonderfaelle =
        this.getSonderfaelleFormArray()?.value ?? [];
      antragTicketUpdateDTOtemp.geschwisterkind1Id =
        this.getFormItem('geschwisterkind1')?.value?.length !== 0
          ? this.getFormItem('geschwisterkind1').value
          : null;
      antragTicketUpdateDTOtemp.geschwisterkind2Id =
        this.getFormItem('geschwisterkind2')?.value?.length !== 0
          ? this.getFormItem('geschwisterkind2').value
          : null;
      antragTicketUpdateDTOtemp.geschwisterkind3Id =
        this.getFormItem('geschwisterkind3')?.value?.length !== 0
          ? this.getFormItem('geschwisterkind3').value
          : null;
      antragTicketUpdateDTOtemp.geschwisterkind4Id =
        this.getFormItem('geschwisterkind4')?.value?.length !== 0
          ? this.getFormItem('geschwisterkind4').value
          : null;
      antragTicketUpdateDTOtemp.geschwisterkind5Id =
        this.getFormItem('geschwisterkind5')?.value?.length !== 0
          ? this.getFormItem('geschwisterkind5').value
          : null;
      antragTicketUpdateDTOtemp.referenzFuerZahlungen = this.getFormItem(
        'referenzFuerZahlungen',
      ).value;
      antragTicketUpdateDTOtemp.einstieghaltestelleId =
        this.getFormItem('einstieghaltestelleId')?.value ?? null;
      antragTicketUpdateDTOtemp.ausstieghaltestelleHinwegId =
        this.getFormItem('ausstieghaltestelleHinwegId')?.value ?? null;
      //add first day to Month from ('2022-08') to ('2022-08-01')
      if (this.isMonthSelection) {
        antragTicketUpdateDTOtemp.aboGueltigkeit =
          this.getFormItem('aboGueltigkeit')?.value?.length > 0
            ? new Date(
                this.getFormItem('aboGueltigkeit')?.value?.toString() + '-01',
              )
            : null;
      }
      const antragTicketSepaUpdateDTOtemp: AntragTicketSepaUpdateDTO =
        {} as AntragTicketSepaUpdateDTO;
      this.autoCreateDTO(
        antragTicketSepaUpdateDTOtemp,
        this.antragTicketSepaFormFields,
      );
      antragTicketUpdateDTOtemp.status = targetStatus;
      antragTicketSepaUpdateDTOtemp.isAntragstellerMandatsgeber =
        this.getFormItem('isAntragstellerNotMandatsgeber')?.value?.length !== 0
          ? !this.getFormItem('isAntragstellerNotMandatsgeber').value
          : undefined;
      antragTicketUpdateDTOtemp.antragTicketSepa =
        antragTicketSepaUpdateDTOtemp;
      antragTicketUpdateDTOtemp.schuelerId =
        this.getFormItem('schueler')?.value ?? null;

      // Saving a draft (ENTWURF) must not validate the Schulangaben.
      this.schoolInfoComponent
        .updateSchoolInfo(targetStatus !== TicketAntragStatus.ENTWURF)
        .subscribe({
        next: () => {
          // School info update successful, proceed with antrag update
          this.antragTicketService
            .updateAntrag(
              parseInt(this.antragTicketId),
              antragTicketUpdateDTOtemp,
            )
            .pipe(
              catchError((err) => {
                if (err.status === 422) {
                  let message = this.translateService.instant(
                    'VALIDIERUNG.MESSAGE',
                  );
                  for (const entry of err.error) {
                    if (
                      entry.path?.includes('attachments') &&
                      entry.error === 'REQUIRED_FIELD_MISSING'
                    ) {
                      message += this.translateService.instant(
                        'VALIDIERUNG.ERRORS.TICKET_ANTRAG.ATTACHMENT_MISSING',
                        entry.details,
                      );
                    } else if (entry.error === 'REQUIRED_FIELD_MISSING') {
                      message += this.translateService.instant(
                        'VALIDIERUNG.ERRORS.' + entry.error,
                        { fieldName: entry.path },
                      );
                    } else if (
                      entry.error === 'ANTRAGSTELLER_MUST_HAVE_MINIMUM_AGE'
                    ) {
                      message += this.translateService.instant(
                        'VALIDIERUNG.ERRORS.' + entry.error,
                      );
                    } else if (entry.path) {
                      message += this.translateService.instant(
                        'VALIDIERUNG.ERRORS.' + entry.error,
                        { fieldName: entry.path },
                      );
                    } else {
                      message += this.translateService.instant(
                        'VALIDIERUNG.ERRORS.' + entry.error,
                      );
                    }
                  }
                  this.customToastService.showError(message);
                  resolve(false);
                  return EMPTY;
                }
                if (err.error.message == 'required_fields_not_present') {
                  this.customToastService.showError(
                    this.translateService.instant(
                      'TICKETDETAIL.ERROR.ANTRAG_SAVE_FAILED_REQUIRED',
                    ),
                  );
                } else {
                  this.customToastService.showError(
                    this.translateService.instant(
                      'TICKETDETAIL.ERROR.ANTRAG_SAVE_FAILED',
                    ),
                  );
                }
                resolve(false);
                return EMPTY;
              }),
            )
            .subscribe((data: AntragTicketDTO) => {
              this.antragTicket = { ...data };
              resolve(true);
            });
        },
        error: (err) => {
          // School info update failed, don't proceed with antrag update
          console.error('School info update failed, antrag not updated:', err);
          resolve(false);
        },
      });
    });
  }

  //DECISION EINREICHEN
  showDecisionModal(
    targetStatus: TicketAntragStatus,
    saveMsg: string,
    goToPath: string,
  ) {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title =
      this.textbausteinService.printTextbausteinByKey(
        KeyString.ANTRAGTICKET_EINREICHEN_MODAL_TITEL,
        this.translateService.instant('MODAL.ANTRAG_EINREICHEN_MODAL_TITEL'),
      );
    modalRef.componentInstance.text =
      this.textbausteinService.printTextbausteinByKey(
        KeyString.ANTRAGTICKET_EINREICHEN_MODAL_TEXT,
        this.translateService.instant('MODAL.ANTRAG_EINREICHEN_MODAL_TEXT'),
      );
    modalRef.componentInstance.yesbuttontext = this.translateService.instant(
      'MODAL.ANTRAG_EINREICHEN_MODAL_TITEL',
    );
    modalRef.componentInstance.nobuttontext = this.translateService.instant(
      'APPLICATION.BUTTON_ABBRECHEN',
    );

    modalRef.componentInstance.onYes = () => {
      this.showSpinner();
      this.updateAntragTicket(targetStatus, saveMsg, goToPath);
    };
  }

  //SAVE
  saveOrUpdate(
    targetStatus: TicketAntragStatus,
    saveMsg: string,
    goToPath: string,
  ) {
    this.showSpinner();
    if (
      this.getFormItem('schwerbehinderung').value == null ||
      this.getFormItem('schwerbehinderung').value == undefined
    ) {
      this.antragTicketForm.patchValue({ schwerbehinderung: false });
    }
    if (
      this.getFormItem('richtigkeitDerAngaben').value == null ||
      this.getFormItem('richtigkeitDerAngaben').value == undefined
    ) {
      this.antragTicketForm.patchValue({ richtigkeitDerAngaben: false });
    }
    if (
      this.getFormItem('datenschutz').value == null ||
      this.getFormItem('datenschutz').value == undefined
    ) {
      this.antragTicketForm.patchValue({ datenschutz: false });
    }
    if (
      this.getFormItem('vertragsbedingungen').value == null ||
      this.getFormItem('vertragsbedingungen').value == undefined
    ) {
      this.antragTicketForm.patchValue({ vertragsbedingungen: false });
    }
    if (
      this.getFormItem('angabenKorrekt').value == null ||
      this.getFormItem('angabenKorrekt').value == undefined
    ) {
      this.antragTicketForm.patchValue({ angabenKorrekt: false });
    }
    if (
      this.getFormItem('tarifbestimmungenZugestimmt').value == null ||
      this.getFormItem('tarifbestimmungenZugestimmt').value == undefined
    ) {
      this.antragTicketForm.patchValue({ tarifbestimmungenZugestimmt: false });
    }
    if (
      this.getFormItem('marketingfreigabe').value == null ||
      this.getFormItem('marketingfreigabe').value == undefined
    ) {
      this.antragTicketForm.patchValue({ marketingfreigabe: false });
    }
    if (
      this.getFormItem('isAntragstellerNotMandatsgeber').value == null ||
      this.getFormItem('isAntragstellerNotMandatsgeber').value == undefined
    ) {
      this.antragTicketForm.patchValue({
        isAntragstellerNotMandatsgeber: false,
      });
    }
    //if vormund Input is not set, set all vormund fields to null
    if (!this.isVormundCheckboxChecked) {
      this.resetFormValues(this.vormundFields);
    }
    if (targetStatus == TicketAntragStatus.EINGEREICHT) {
      this.isSubmitted = true;
      this.applyValidators()
        .then(() => {
          this.hideSpinner();
          // The school info lives in its own form (SchoolInfoComponent), so it is not covered by
          // antragTicketForm.valid - check it explicitly, otherwise the submit modal would open
          // although required Schulangaben are missing.
          const schoolInfoForm = this.schoolInfoComponent?.form;
          if (schoolInfoForm) {
            this.schoolInfoComponent.setValidators();
            schoolInfoForm.markAllAsTouched();
          }
          if (!this.antragTicketForm.valid) {
            this.customToastService.showError(
              this.translateService.instant('TICKETDETAIL.ERROR.FORM_INVALID') +
                this.getNotValid(),
            );
          } else if (schoolInfoForm?.invalid) {
            this.customToastService.showError(
              this.translateService.instant(
                'TICKETDETAIL.SCHOOL_INFO.UPDATE_ERROR_FORM_INVALID',
              ),
            );
          } else if (this.isAntragstellerYoungerThanMinimumAge) {
            this.customToastService.showError(
              this.translateService.instant(
                'TICKETDETAIL.ERROR.ANTRAGSTELLER_TOO_YOUNG',
                {
                  minAge: this.configService.featureConfig.minimumAge,
                },
              ),
            );
          } else {
            this.showDecisionModal(targetStatus, saveMsg, goToPath);
          }
        })
        .catch((err) => console.log(err));
    } else if (targetStatus == TicketAntragStatus.ENTWURF) {
      this.isSubmitted = false;
      this.clearAllValidators();
      this.updateAntragTicket(targetStatus, saveMsg, goToPath);
    }
  }

  deleteDraft() {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title =
      this.textbausteinService.printTextbausteinByKey(
        KeyString.ENTWURF_LOESCHEN_MODAL_TITEL,
        this.translateService.instant('MODAL.ENTWURF_LOESCHEN_MODAL_TITEL'),
      );
    modalRef.componentInstance.text =
      this.textbausteinService.printTextbausteinByKey(
        KeyString.ENTWURF_LOESCHEN_MODAL_TEXT,
        this.translateService.instant('MODAL.ENTWURF_LOESCHEN_MODAL_TEXT'),
      );
    modalRef.componentInstance.onYes = () => {
      this.antragTicketService
        .deleteAntrag(parseInt(this.antragTicketId))
        .pipe(
          catchError(() => {
            this.customToastService.showError(
              this.translateService.instant(
                'MODAL.ENTWURF_LOESCHEN_MODAL_ERROR',
              ),
            );
            return EMPTY;
          }),
        )
        .subscribe(() => {
          this.router
            .navigate(['/pages/ticketTabelle'])
            .then(() => {
              this.customToastService.showSuccess(
                this.translateService.instant(
                  'MODAL.ENTWURF_LOESCHEN_MODAL_SUCCESS',
                ),
              );
            })
            .catch(() => {});
        });
    };
  }

  // fields explicitly allowed to be copied via copyAntrag(); everything else (Sonderfall, Checkboxen,
  // Antragsstatus, Kommentarfelder, Postkorbreferenz, Wiedervorlagedatum, Vertragsbeginn/antragsdatum) stays out
  private readonly antragTicketCopyFields = [
    'name',
    'vorname',
    'strasse',
    'plz',
    'ort',
    'geburtsdatum',
    'email',
    'emailSchueler',
    'telefonnummer',
    'schwerbehinderung',
    'geschlecht',
    'schueler',
    'land',
    'adresszusatz',
    'vormundName',
    'vormundVorname',
    'isVormundadresseAbweichend',
    'vormundStrasse',
    'vormundOrt',
    'vormundPlz',
    'vormundAdresszusatz',
    'vormundLand',
    'vormundGeburtsdatum',
    'vormundTelefonnummer',
    'vormundEmail',
    'vormundGeschlecht',
    'wegtyp',
    'fachbereichId',
    'ticketId',
    'einstieghaltestelleId',
    'ausstieghaltestelleHinwegId',
    'praktikumStelle',
    'praktikumHinweis',
    'praktikumStrasse',
    'praktikumOrt',
    'praktikumPlz',
    'praktikumLand',
    'praktikumAdresszusatz',
    'praktikumStartdatum',
    'praktikumEnddatum',
    'praktikumstageJeWoche',
    'geschwisterkind1',
    'geschwisterkind2',
    'geschwisterkind3',
    'geschwisterkind4',
    'geschwisterkind5',
  ];

  private readonly antragTicketSepaCopyFields = [
    'vornameSepa',
    'nameSepa',
    'strasseSepa',
    'plzSepa',
    'ortSepa',
    'adresszusatzSepa',
    'landSepa',
    'emailSepa',
    'telefonnummerSepa',
    'geburtsdatumSepa',
    'geschlechtSepa',
    'iban',
    'ibanSepa',
    'bicSepa',
    'bic',
    'nameKreditinstitut',
    'nameKreditinstitutSepa',
    'datenschutz',
    'vertragsbedingungen',
    'isAntragstellerMandatsgeber',
  ];

  async copyAntrag(): Promise<void> {
    const antragTicketClone: Partial<AntragTicketDTO> = {};
    for (const field of this.antragTicketCopyFields) {
      if (field.startsWith('geschwisterkind')) {
        continue; // Geschwister is copied separately below, from the live form/selection
      }
      antragTicketClone[field] = this.antragTicket?.[field];
    }

    // Whether/what to copy for the Mandat (SEPA) must come from the LIVE FORM, not from `this.antragTicket`
    // (a stale, last-saved-from-backend snapshot): the user may have entered/edited IBAN/BIC/etc. without
    // saving before copying, which would otherwise be silently dropped.
    const isAntragstellerNotMandatsgeber = this.getFormItem(
      'isAntragstellerNotMandatsgeber',
    )?.value;
    const sepaHasData = !!(
      this.getFormItem('iban')?.value ||
      this.getFormItem('ibanSepa')?.value ||
      this.getFormItem('bic')?.value ||
      this.getFormItem('bicSepa')?.value ||
      this.getFormItem('nameKreditinstitut')?.value ||
      this.getFormItem('nameKreditinstitutSepa')?.value
    );
    if (sepaHasData) {
      antragTicketClone.antragTicketSepa =
        {} as AntragTicketDTO['antragTicketSepa'];
      for (const field of this.antragTicketSepaCopyFields) {
        if (field === 'isAntragstellerMandatsgeber') {
          continue;
        }
        antragTicketClone.antragTicketSepa[field] =
          this.getFormItem(field)?.value;
      }
      antragTicketClone.antragTicketSepa.isAntragstellerMandatsgeber =
        isAntragstellerNotMandatsgeber === undefined
          ? undefined
          : !isAntragstellerNotMandatsgeber;
    }

    // Geschwister likewise comes from the live form (id + display fields), not from
    // `this.antragTicket.geschwisterkindN`, which only reflects the last-saved backend state.
    for (const nr of [1, 2, 3, 4, 5]) {
      const id = this.getFormItem('geschwisterkind' + nr)?.value;
      antragTicketClone['geschwisterkind' + nr] = id
        ? ({
            id,
            name: this.getFormItem('geschwisterkind' + nr + 'name')?.value,
            vorname: this.getFormItem('geschwisterkind' + nr + 'vorname')
              ?.value,
            geburtsdatum: this.getFormItem(
              'geschwisterkind' + nr + 'geburtsdatum',
            )?.value,
            strasse: this.getFormItem('geschwisterkind' + nr + 'strasse')
              ?.value,
            plz: this.getFormItem('geschwisterkind' + nr + 'plz')?.value,
            ort: this.getFormItem('geschwisterkind' + nr + 'ort')?.value,
          } as SchuelerDTO)
        : null;
    }

    // Schuldaten (Schule/Schuljahr/Klasse/Bildungsgang) are managed as a separate entity keyed by antragId;
    // the source values are read directly from the school-info child component and re-applied once the
    // copied draft has received its own antragId (see importCopiedAntragFromSessionStorage()).
    const sourceSchoolInfo = this.schoolInfoComponent?.schoolInfo;
    const schoolInfoCopy: AntragTicketSchoolInfoUpdateDto = sourceSchoolInfo
      ? {
          schoolId: sourceSchoolInfo.schoolRef?.schoolId || null,
          schoolYearId: sourceSchoolInfo.schoolYearRef?.schoolYearId || null,
          classId: sourceSchoolInfo.classRef?.classId || null,
          courseId: sourceSchoolInfo.courseRef?.courseId || null,
          schoolDaysAWeek: this.antragTicket?.schultageJeWoche || null,
          courseDate: this.antragTicket?.bildungsgangdatum || null,
          schoolLevel: sourceSchoolInfo.schoolLevel || null,
        }
      : null;

    await this.secureSessionStorageService.set('antragTicketCopy', {
      antragTicket: antragTicketClone,
      schoolInfo: schoolInfoCopy,
    });
    this.showSpinner();
    this.antragTicketService
      .createNewEntwurf()
      .pipe(
        catchError(() => {
          this.hideSpinner();
          this.customToastService.showError(
            this.translateService.instant(
              'TICKETDETAIL.ERROR.ANTRAG_LOAD_FAILED',
            ),
          );
          return EMPTY;
        }),
      )
      .subscribe((newId: number) => {
        if (newId) {
          this.router
            .navigate(['/pages/ticket-detail/' + newId])
            .catch(() => {});
        } else {
          this.hideSpinner();
          this.customToastService.showError(
            this.translateService.instant(
              'TICKETDETAIL.ERROR.ANTRAG_LOAD_FAILED',
            ),
          );
        }
      });
  }

  /**
   * Applies data copied via copyAntrag() onto the newly created (still empty) draft. Called once the
   * draft has been loaded via antragObs$, ie once this.antragTicket/this.antragTicketId are populated.
   */
  private async importCopiedAntragFromSessionStorage(): Promise<void> {
    const copiedData = await this.secureSessionStorageService.get<{
      antragTicket: Partial<AntragTicketDTO>;
      schoolInfo: AntragTicketSchoolInfoUpdateDto;
    }>('antragTicketCopy');
    if (!copiedData) {
      return;
    }
    this.secureSessionStorageService.remove('antragTicketCopy');
    const copiedAntragTicket = copiedData?.antragTicket;
    if (!copiedAntragTicket) {
      return;
    }

    this.antragTicket = { ...this.antragTicket, ...copiedAntragTicket };
    this.autoPatchForm(this.antragTicket, this.antragTicketCopyFields);

    if (this.antragTicket.antragTicketSepa) {
      this.autoPatchForm(
        this.antragTicket.antragTicketSepa,
        this.antragTicketSepaCopyFields,
      );
      if (
        this.antragTicket.antragTicketSepa.isAntragstellerMandatsgeber !=
        undefined
      ) {
        this.antragTicketForm.patchValue({
          isAntragstellerNotMandatsgeber:
            !this.antragTicket.antragTicketSepa.isAntragstellerMandatsgeber,
        });
      }
    }

    for (const nr of [1, 2, 3, 4, 5]) {
      const geschwisterkind = this.antragTicket['geschwisterkind' + nr];
      if (geschwisterkind) {
        this.autoPatchForm(
          geschwisterkind,
          this['antragTicketGeschwister' + nr + 'FormFields'],
        );
        this.setGeschwisterkind(nr);
      }
    }

    const schoolInfoCopy: AntragTicketSchoolInfoUpdateDto =
      copiedData?.schoolInfo;
    if (schoolInfoCopy && this.antragTicket?.antragId) {
      this.antragTicketSchoolInfoService
        .updateSchoolInfoByAntrag(this.antragTicket.antragId, schoolInfoCopy)
        .subscribe({
          next: () => {
            this.schoolInfoComponent?.getSchoolInfo();
          },
          error: () => {
            this.customToastService.showError(
              this.translateService.instant(
                'TICKETDETAIL.SCHOOL_INFO.UPDATE_ERROR',
                { errorCode: 'unknown' },
              ),
            );
          },
        });
    }
  }

  loadNextPageEinstiegHaltestelle() {
    //nachladen wenn scrolling am Ende der Liste angekommen ist
    if (
      this.einstiegHaltestellePage.totalPages >
      this.einstiegHaltestellePagination.offset + 1
    ) {
      this.einstiegHaltestellePagination.offset =
        this.einstiegHaltestellePagination.offset + 1;
      this.updateEinstiegshaltestelle();
    }
  }

  loadErrorMessage() {
    this.customToastService.showError(
      this.translateService.instant('TICKETDETAIL.ERROR.DATA_LOAD_ERROR'),
    );
    this.router.navigate(['pages/ticket-table']).catch(() => {});
  }

  loadDataErrorMessage(data: string) {
    this.customToastService.showError(
      this.translateService.instant(
        'TICKETDETAIL.ERROR.DATA_LOAD_ERROR_DETAIL',
      ) + data,
    );
    this.router.navigate(['pages/ticket-table']).catch(() => {});
  }

  updateEinstiegshaltestelle() {
    this.einstiegHaltestelleLoading = true;
    this.haltestelleService
      .getHaltestellenPage(
        this.paginationService.getHttpParamsForPagination(
          this.einstiegHaltestellePagination,
        ),
      )
      .subscribe((pageDto) => {
        this.einstiegHaltestelleLoading = false;
        this.einstiegHaltestellePagination.count = pageDto.currentCount;
        this.einstiegHaltestellePage = pageDto;
        const list =
          this.haltestelleDisplayComboNameService.haltestellenListToMinimalList(
            pageDto.items,
          );
        if (this.einstiegHaltestellePage.page === 0) {
          this.einstiegHaltestelleList = list;
        } else {
          this.einstiegHaltestelleList =
            this.einstiegHaltestelleList.concat(list);
        }
        if (this.antragTicket?.einstieghaltestelle) {
          const minDto =
            this.haltestelleDisplayComboNameService.haltestellenListToMinimalList(
              [this.antragTicket.einstieghaltestelle],
            )[0];
          if (this.einstiegHaltestelleList.indexOf(minDto) < 0)
            this.einstiegHaltestelleList.push(minDto);
        }
      });
  }

  checkForHaltestellenMatch(caller: string) {
    if (!this.antragTicketForm.get(caller)?.value) return;
    const einstieg =
      this.antragTicketForm.get('einstieghaltestelleId')?.value ?? undefined;
    const ausstieg =
      this.antragTicketForm.get('ausstieghaltestelleHinwegId')?.value ??
      undefined;
    if (einstieg == ausstieg) {
      this.antragTicketForm
        .get(caller)
        .patchValue(undefined, { emitEvent: false, onlySelf: true });
      this.customToastService.showError(
        this.translateService.instant('TICKETDETAIL.ERROR.HALTESTELLEN_MATCH'),
      );
    }
  }

  filterEinstieghaltestelle() {
    const valName = (
      document.getElementById(
        'select-einstieghaltestelleId',
      ) as HTMLInputElement
    ).value
      .toString()
      .toLowerCase();
    const filterString = this.getFilterStringForServer(valName);
    if (filterString.length > 0) {
      this.einstiegHaltestellePagination.filter = filterString;
      this.einstiegHaltestellePagination.offset = 0;
      this.updateEinstiegshaltestelle();
    } else {
      this.einstiegHaltestelleList = null;
    }
  }

  setOrt(event, formItem: string) {
    this.postleitzahlenService
      .resolvePlzDetails(event.target.value)
      .subscribe((result) => {
        if (result !== null) {
          this.getFormItem(formItem)?.patchValue(result.ort);
        }
      });
  }

  getFilterStringForServer(value: string) {
    return !value || value.trim().length < 2 ? '' : 'name:' + value;
  }

  initListsForSBtrue(): Observable<any> {
    const schulenObservable = this.schuleService.getSchulenForAntrag().pipe(
      tap((schulen) => {
        this.schuleList = schulen;
        if (!schulen || schulen.length < 1) {
          this.loadDataErrorMessage(
            this.translateService.instant('COMPOSITE-MESSAGE.PLURAL.SCHULE'),
          );
        }
      }),
      catchError(() => {
        this.loadErrorMessage();
        return of(null);
      }),
    );

    // Chain both schuljahr calls (non-BK + BK) into a single observable using switchMap.
    // forkJoin waits for the ENTIRE chain, preventing the race condition where
    // schuljahreList was still empty when SchoolInfoComponent tried to map UUIDs.
    const schuljahreObservable = this.schuljahrService
      .getSchuljahreBerufskolleg(true, false)
      .pipe(
        switchMap((schuljahre) =>
          this.schuljahrService.getSchuljahreBerufskolleg(true, true).pipe(
            tap((schuljahreBerufskolleg) => {
              this.schuljahreList = [...schuljahre, ...schuljahreBerufskolleg];
              this.filteredSchuljahreList = this.schuljahreList;
              if (this.schuljahreList.length < 1) {
                this.loadDataErrorMessage(
                  this.translateService.instant('PLURAL.SCHULJAHR'),
                );
              }
            }),
          ),
        ),
        catchError(() => {
          this.loadErrorMessage();
          return of(null);
        }),
      );

    const schuelerListObservable = this.schuelerService.getSchuelerList().pipe(
      tap((schueler) => {
        if (!schueler || schueler.length === 0 || !Array.isArray(schueler))
          return;
        schueler.forEach((gizmo) => {
          this.schuelerList = [
            ...this.schuelerList,
            { id: gizmo.id, fullName: '' + gizmo.vorname + ' ' + gizmo.name },
          ];
        });
      }),
      catchError(() => {
        this.loadErrorMessage();
        return of(null);
      }),
    );

    return forkJoin([
      schulenObservable,
      schuljahreObservable,
      schuelerListObservable,
    ]);
  }

  checkIfVorgaengerExists() {
    if (
      this.readonly ||
      this.isInitializing ||
      !this.antragTicketForm ||
      !this.antragTicketId
    )
      return;

    this.resetFormValues([
      'name',
      'vorname',
      'strasse',
      'plz',
      'ort',
      'land',
      'adresszusatz',
      'geburtsdatum',
      'isSchuelerUnderAge',
      'emailSchueler',
      'telefonnummer',
      'geschlecht',
      'schuelernummer',
      'geschwisterkind1',
      'geschwisterkind2',
      'geschwisterkind3',
      'geschwisterkind4',
      'geschwisterkind5',
      'aboGueltigkeit',
    ]);
    this.resetFormValidators([
      'name',
      'vorname',
      'strasse',
      'plz',
      'ort',
      'land',
      'adresszusatz',
      'geburtsdatum',
      'isSchuelerUnderAge',
      'emailSchueler',
      'telefonnummer',
      'geschlecht',
      'schuelernummer',
      'geschwisterkind1',
      'geschwisterkind2',
      'geschwisterkind3',
      'geschwisterkind4',
      'geschwisterkind5',
      'aboGueltigkeit',
    ]);

    this.isInitializing = true;

    const schuelerId = this.getFormItem('schueler')?.value;

    let vorgaenger: AntragTicketDTO = undefined;
    if (schuelerId) {
      this.antragTicketService.getVorgaenger(schuelerId).subscribe((result) => {
        vorgaenger = result;

        if (vorgaenger) {
          this.customToastService.showInfo(
            this.translateService.instant(
              'TICKETDETAIL.INFO.VORGAENGER_TOAST',
              { vorgaengerId: vorgaenger.id },
            ),
            'Information',
          );

          // make sure einstieghaltestelleList is prepopulated with einstieghaltestelleId loaded with antrag
          const haltestelle = vorgaenger.einstieghaltestelle;
          if (haltestelle) {
            this.einstiegHaltestelleList = this.einstiegHaltestelleList.concat({
              id: haltestelle.id,
              name: haltestelle.name,
              tarifgebietName: haltestelle.tarifgebietName,
              comboName:
                this.haltestelleDisplayComboNameService.getComboName(
                  haltestelle,
                ),
              archiv: haltestelle.archiv,
            });
          }

          // do not patch schule/schuljahr-dependent things (ticketart, ausstieghaltestelle etc.) from vorgaenger
          // because schule loaded from schueler object below may not have association to old ticketart, ausstieghaltestelle etc.

          this.antragTicketForm.patchValue({
            emailSchueler: vorgaenger?.emailSchueler || undefined,
            einstieghaltestelleId:
              vorgaenger.einstieghaltestelle?.id || undefined,
          });
          this.populateSonderfaelleFormArray(vorgaenger.sonderfaelle, false);
          this.sonderfaelleChange();
        } else {
          // no vorgaenger antrag => basic data data
          this.antragTicketForm.patchValue({
            emailSchueler: undefined,
          });
        }

        // always get this data from schueler whether vorgaenger is present or not
        this.schuelerService.getSchueler(schuelerId).subscribe((result) => {
          const schueler = result;
          //TODO: Patch schule in new SchoolInfoComponent
          // const schule = getObjIfExistsInListByAttribute(schueler.schule, this.schuleList, 'name') as SchuleDTO;
          this.antragTicketForm.patchValue({
            name: schueler?.name || undefined,
            vorname: schueler?.vorname || undefined,
            strasse: schueler?.strasse || undefined,
            plz: schueler?.plz || undefined,
            ort: schueler?.ort || undefined,
            land: schueler?.land || 'DEUTSCHLAND',
            adresszusatz: schueler?.adresszusatz || undefined,
            geburtsdatum: schueler?.geburtsdatum || undefined,
            geschlecht: schueler?.geschlecht || undefined,
            schuelernummer: schueler.schuelernummer || undefined,
          });
          this.schuelerDeleted = schueler.deleted;
        });
      });
    } else {
      // no vorgaenger and no schueler / schuelerId
      this.antragTicketForm.patchValue({
        name: null,
        vorname: null,
        strasse: null,
        plz: null,
        ort: null,
        land: null,
        adresszusatz: null,
        geburtsdatum: null,
        emailSchueler: null,
        schwerbehinderung: null,
        geschlecht: null,
        schuelernummer: null,
      });
      this.schuelerDeleted = false;
    }

    this.setButtonVisibility();
    this.checkAntragstellerAge();
    this.vormundChange();
    this.isInitializing = false;
  }

  getFormItem(s: string) {
    return this.antragTicketForm?.get(s);
  }

  dynamicWidth(field: string) {
    const len = this.getFormItem(field)?.value
      ? this.getFormItem(field).value.length + 1
      : 0;
    return 'width:' + len + 'ch;';
  }

  setGeschwisterkind(nr: number) {
    const varName = 'geschwisterkind' + nr;
    const schuelerIdgeschwister = this.getFormItem(varName)?.value;
    if (!schuelerIdgeschwister) return;
    const numbersToCompare = [1, 2, 3, 4, 5];
    numbersToCompare.splice(numbersToCompare.indexOf(nr), 1);
    let selectedSchueler: SchuelerDTO;

    //case first edit
    if (this.getFormItem('schueler')?.value?.length > 0) {
      let schuelerIdsToCompare = [this.getFormItem('schueler')?.value];
      numbersToCompare.forEach(
        (num) =>
          (schuelerIdsToCompare = [
            ...schuelerIdsToCompare,
            this.getFormItem('geschwisterkind' + num).value,
          ]),
      );
      if (schuelerIdsToCompare.indexOf(schuelerIdgeschwister) > -1) {
        this.getFormItem(varName)?.patchValue('');
        this.customToastService.showError(
          this.translateService.instant('TICKETDETAIL.GESCHWISTER_DUPLICATE'),
        );
        return;
      }
    } else {
      //Case load entwurf
      //schuelerIdsToCompare == null
      let schuelerToCompare = [
        this.getFormItem('name')?.value +
          this.getFormItem('vorname')?.value +
          this.getFormItem('geburtsdatum')?.value +
          this.getFormItem('plz')?.value +
          this.getFormItem('strasse')?.value +
          this.getFormItem('ort')?.value,
      ];
      numbersToCompare.forEach(
        (num) =>
          (schuelerToCompare = [
            ...schuelerToCompare,
            this.getFormItem('geschwisterkind' + num + 'name')?.value +
              this.getFormItem('geschwisterkind' + num + 'vorname')?.value +
              this.getFormItem('geschwisterkind' + num + 'geburtsdatum')
                ?.value +
              this.getFormItem('geschwisterkind' + num + 'plz')?.value +
              this.getFormItem('geschwisterkind' + num + 'strasse')?.value +
              this.getFormItem('geschwisterkind' + num + 'ort')?.value,
          ]),
      );

      this.schuelerService
        .getSchueler(schuelerIdgeschwister)
        .subscribe((schueler) => {
          if (schueler) {
            selectedSchueler = schueler;
            const schuelerCompareStringGeschwister =
              schueler['name'] +
              schueler['vorname'] +
              schueler['geburtsdatum'] +
              schueler['plz'] +
              schueler['strasse'] +
              schueler['ort'];
            if (
              schuelerToCompare.indexOf(schuelerCompareStringGeschwister) > -1
            ) {
              this.getFormItem(varName)?.patchValue('');
              this.customToastService.showError(
                this.translateService.instant(
                  'TICKETDETAIL.GESCHWISTER_DUPLICATE',
                ),
              );
              return;
            }
          }
        });
    }

    if (selectedSchueler) {
      this.patchSchuelerFields(selectedSchueler, nr);
    } else {
      this.schuelerService
        .getSchueler(schuelerIdgeschwister)
        .subscribe((schueler) => {
          this.patchSchuelerFields(schueler, nr);
        });
    }
  }

  private patchSchuelerFields(schueler: SchuelerDTO, nr: number) {
    const varName = 'geschwisterkind' + nr;
    if (schueler) {
      const fieldsToPatch = [
        'name',
        'vorname',
        'geburtsdatum',
        'strasse',
        'plz',
        'ort',
      ];
      fieldsToPatch.forEach((field) => {
        this.antragTicketForm.patchValue({
          [varName + field]: schueler[field],
        });
      });
      this.antragTicketForm.patchValue({
        [varName + 'schuleId']: schueler['schule']
          ? schueler['schule']['id']
          : 'Keine',
      });
    }
  }

  initEmptyForm() {
    this.antragTicketForm = this.fb.group({
      name: undefined,
      vorname: undefined,
      strasse: undefined,
      plz: undefined,
      ort: undefined,
      geburtsdatum: undefined,
      email: undefined,
      emailSchueler: undefined,
      telefonnummer: undefined,
      schwerbehinderung: undefined,
      aboGueltigkeit: undefined,
      ticketId: undefined,
      fachbereichId: undefined,
      geschlecht: undefined,
      einstieghaltestelleId: undefined,
      ausstieghaltestelleHinwegId: undefined,
      referenzFuerZahlungen: undefined,
      abonnementnummerAntrag: undefined,
      bemerkungAntragsteller: [undefined, [Validators.maxLength(2000)]],
      einverstaendnisErklaerung: undefined,

      geschwisterkind1: undefined,
      geschwisterkind2: undefined,
      geschwisterkind3: undefined,
      geschwisterkind4: undefined,
      geschwisterkind5: undefined,

      geschwisterkind1name: undefined,
      geschwisterkind1vorname: undefined,
      geschwisterkind1geburtsdatum: undefined,
      geschwisterkind1strasse: undefined,
      geschwisterkind1plz: undefined,
      geschwisterkind1ort: undefined,
      geschwisterkind1schule: undefined,

      geschwisterkind2name: undefined,
      geschwisterkind2vorname: undefined,
      geschwisterkind2geburtsdatum: undefined,
      geschwisterkind2strasse: undefined,
      geschwisterkind2plz: undefined,
      geschwisterkind2ort: undefined,
      geschwisterkind2schule: undefined,

      geschwisterkind3name: undefined,
      geschwisterkind3vorname: undefined,
      geschwisterkind3geburtsdatum: undefined,
      geschwisterkind3strasse: undefined,
      geschwisterkind3plz: undefined,
      geschwisterkind3ort: undefined,
      geschwisterkind3schule: undefined,

      geschwisterkind4name: undefined,
      geschwisterkind4vorname: undefined,
      geschwisterkind4geburtsdatum: undefined,
      geschwisterkind4strasse: undefined,
      geschwisterkind4plz: undefined,
      geschwisterkind4ort: undefined,
      geschwisterkind4schule: undefined,

      geschwisterkind5name: undefined,
      geschwisterkind5vorname: undefined,
      geschwisterkind5geburtsdatum: undefined,
      geschwisterkind5strasse: undefined,
      geschwisterkind5plz: undefined,
      geschwisterkind5ort: undefined,
      geschwisterkind5schule: undefined,

      schuelernummer: undefined,
      richtigkeitDerAngaben: undefined,
      typ: undefined,
      schueler: undefined,
      marketingfreigabe: undefined,

      land: 'DEUTSCHLAND',
      vormundName: undefined,
      vormundVorname: undefined,
      isVormundadresseAbweichend: undefined,
      vormundStrasse: undefined,
      vormundOrt: undefined,
      vormundPlz: undefined,
      vormundAdresszusatz: undefined,
      vormundLand: undefined,
      vormundGeburtsdatum: undefined,
      vormundTelefonnummer: undefined,
      vormundEmail: undefined,
      vormundGeschlecht: undefined,
      wegtyp: undefined,
      praktikumHinweis: undefined,
      praktikumStelle: undefined,
      praktikumStrasse: undefined,
      praktikumOrt: undefined,
      praktikumPlz: undefined,
      praktikumLand: undefined,
      praktikumAdresszusatz: undefined,
      praktikumStartdatum: undefined,
      praktikumEnddatum: undefined,
      praktikumstageJeWoche: undefined,
      sonderfallEnabled: undefined,
      sonderfaelle: this.fb.array([]),
      bezugAsylbewerberleistungsgesetz: undefined,
      adresszusatz: undefined,
      zustimmungGesetzlicherVertreter: undefined,
      angabenKorrekt: undefined,
      tarifbestimmungenZugestimmt: undefined,

      // attachments
      praktikumsvertrag: undefined,
      sonderfallNachweis: undefined,
      bezugNachweis: undefined,

      // SEPA
      vornameSepa: undefined,
      nameSepa: undefined,
      strasseSepa: undefined,
      plzSepa: undefined,
      ortSepa: undefined,
      adresszusatzSepa: undefined,
      landSepa: undefined,
      emailSepa: undefined,
      telefonnummerSepa: undefined,
      geburtsdatumSepa: undefined,
      geschlechtSepa: undefined,
      iban: undefined,
      ibanSepa: undefined,
      isAntragstellerNotMandatsgeber: undefined,
      datenschutz: undefined,
      vertragsbedingungen: undefined,
      bicSepa: undefined,
      bic: undefined,
      nameKreditinstitut: undefined,
      nameKreditinstitutSepa: undefined,

      status: undefined,
    });
  }

  correctLand() {
    const occurencesOfLand = [
      'land',
      'vormundLand',
      'praktikumLand',
      'landSepa',
    ];
    occurencesOfLand.forEach((occ: string) => {
      const formItem = this.getFormItem(occ);
      if (!formItem) return;

      const landRaw = formItem.value;

      if (typeof landRaw !== 'string') {
        this.antragTicketForm.patchValue({ [occ]: 'DEUTSCHLAND' });
        return;
      }

      const normalizedLand = landRaw.trim().toUpperCase();

      // Default empty/whitespace-only to DEUTSCHLAND
      if (normalizedLand.length < 1) {
        this.antragTicketForm.patchValue({ [occ]: 'DEUTSCHLAND' });
        return;
      }

      const landKeys = Object.keys(Land);
      const isValidLand = landKeys.includes(normalizedLand);

      if (!isValidLand) {
        this.antragTicketForm.patchValue({ [occ]: 'DEUTSCHLAND' });
        return;
      }

      // Normalize to enum key so PLZ validation and backend payload stay consistent
      if (formItem.value !== normalizedLand) {
        this.antragTicketForm.patchValue({ [occ]: normalizedLand });
      }
    });
  }

  setPlzPatternValidator(
    plzControlName: string,
    landControlName: string,
  ): void {
    const land = this.getFormItem(landControlName)?.value;
    if (land) {
      this.getFormItem(plzControlName)?.setValidators([
        Validators.maxLength(this.plzHelper.getMaxPlzLength(land)),
        Validators.pattern(this.plzHelper.getPlzPattern(land)),
      ]);
    } else {
      this.getFormItem(plzControlName)?.clearValidators();
    }
    this.getFormItem(plzControlName)?.updateValueAndValidity();
  }

  getMaxPlzLength(landControlName: string): number {
    return this.plzHelper.getMaxPlzLength(
      this.getFormItem(landControlName)?.value,
    );
  }
  getPlzPattern(landControlName: string): string {
    return this.plzHelper.getPlzPattern(
      this.getFormItem(landControlName)?.value,
    );
  }

  addFormalValidators() {
    if (this.effectivelyVisible?.includes('iban')) {
      this.getFormItem('iban')?.addValidators([ValidatorService.validateIban]);
      this.getFormItem('iban')?.updateValueAndValidity();
    }
    if (this.effectivelyVisible?.includes('ibanSepa')) {
      this.getFormItem('ibanSepa')?.addValidators([
        ValidatorService.validateIban,
      ]);
      this.getFormItem('ibanSepa')?.updateValueAndValidity();
    }
    if (this.effectivelyVisible?.includes('vormundGeburtsdatum')) {
      this.getFormItem('vormundGeburtsdatum')?.addValidators([
        createVormundAgeValidator(),
      ]);
      this.getFormItem('vormundGeburtsdatum')?.updateValueAndValidity();
    }
    if (
      this.effectivelyVisible?.includes('abonnementnummerAntrag') &&
      this.exportConfig?.patrisConfig.enabled
    ) {
      // add validators for abonnementnummerAntrag for patris export
      this.getFormItem('abonnementnummerAntrag')?.addValidators([
        Validators.pattern(this.validationHelper.abonummerPattern),
      ]);
      this.getFormItem('abonnementnummerAntrag')?.updateValueAndValidity();
    }
    if (this.effectivelyVisible?.includes('strasse')) {
      // add validators for strasse and hausnummer
      this.getFormItem('strasse')?.addValidators(
        Validators.pattern(this.validationHelper.strasseHausnummerPattern),
      );
      this.getFormItem('strasse')?.updateValueAndValidity();
    }
    if (this.effectivelyVisible?.includes('vormundStrasse')) {
      // add validators for strasse and hausnummer
      this.getFormItem('vormundStrasse')?.addValidators(
        Validators.pattern(this.validationHelper.strasseHausnummerPattern),
      );
      this.getFormItem('vormundStrasse')?.updateValueAndValidity();
    }
    if (this.effectivelyVisible?.includes('praktikumStrasse')) {
      // add validators for strasse and hausnummer
      this.getFormItem('praktikumStrasse')?.addValidators(
        Validators.pattern(this.validationHelper.strasseHausnummerPattern),
      );
      this.getFormItem('praktikumStrasse')?.updateValueAndValidity();
    }
    if (this.effectivelyVisible?.includes('strasseSepa')) {
      // add validators for strasse and hausnummer
      this.getFormItem('strasseSepa')?.addValidators(
        Validators.pattern(this.validationHelper.strasseHausnummerPattern),
      );
      this.getFormItem('strasseSepa')?.updateValueAndValidity();
    }
    if (this.effectivelyVisible?.includes('telefonnummer')) {
      // add validators for telefonnummer
      this.getFormItem('telefonnummer')?.addValidators(
        Validators.pattern(this.validationHelper.telefonnummerPattern),
      );
      this.getFormItem('telefonnummer')?.updateValueAndValidity();
    }
    if (this.effectivelyVisible?.includes('vormundTelefonnummer')) {
      // add validators for telefonnummer
      this.getFormItem('vormundTelefonnummer')?.addValidators(
        Validators.pattern(this.validationHelper.telefonnummerPattern),
      );
      this.getFormItem('vormundTelefonnummer')?.updateValueAndValidity();
    }
    if (this.effectivelyVisible?.includes('telefonnummerSepa')) {
      // add validators for telefonnummer
      this.getFormItem('telefonnummerSepa')?.addValidators(
        Validators.pattern(this.validationHelper.telefonnummerPattern),
      );
      this.getFormItem('telefonnummerSepa')?.updateValueAndValidity();
    }
    if (this.effectivelyVisible?.includes('emailSchueler')) {
      // add validators for email
      this.getFormItem('emailSchueler')?.addValidators(
        Validators.pattern(this.validationHelper.emailPattern),
      );
      this.getFormItem('emailSchueler')?.updateValueAndValidity();
    }
    if (this.effectivelyVisible?.includes('vormundEmail')) {
      // add validators for email
      this.getFormItem('vormundEmail')?.addValidators(
        Validators.pattern(this.validationHelper.emailPattern),
      );
      this.getFormItem('vormundEmail')?.updateValueAndValidity();
    }
    if (this.effectivelyVisible?.includes('emailSepa')) {
      // add validators for email
      this.getFormItem('emailSepa')?.addValidators(
        Validators.pattern(this.validationHelper.emailPattern),
      );
      this.getFormItem('emailSepa')?.updateValueAndValidity();
    }
  }

  getNotValid(): string {
    let notValid = '';
    const controls = this.antragTicketForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        if (name === 'sonderfallNachweis') {
          notValid +=
            this.translateService.instant(
              'TICKETDETAIL.VALIDATION.FIELD_SONDERFALLNACHWEIS',
            ) + ', ';
        } else if (name === 'bezugNachweis') {
          notValid +=
            this.translateService.instant(
              'TICKETDETAIL.VALIDATION.FIELD_BEZUGNACHWEIS',
            ) + ', ';
        } else if (name === 'praktikumsvertrag') {
          notValid +=
            this.translateService.instant(
              'TICKETDETAIL.VALIDATION.FIELD_PRAKTIKUMSVERTRAG',
            ) + ', ';
        } else {
          const temp = document.getElementById('sfklabel-' + name);
          const inner = temp?.innerHTML?.replace('&nbsp;', '\u00A0');
          notValid +=
            '' +
            (inner?.replace('' + this.pflichtFeldMarker, '').trim() ||
              this.fieldConfigService.getFieldLabel(
                name,
                this.fieldConfig,
                toTitlecase(name),
              )) +
            ', ';
        }
      }
    }
    return notValid.substring(0, notValid.length - 2); // remove last comma
  }

  ngOnDestroy() {
    this.formItemSubscriptions.forEach((subscription) =>
      subscription.unsubscribe(),
    );
    this.hideSpinner();
  }

  private initAboDatumGueltigAb() {
    this.isMonthSelection = this.moduleConfigService.isModuleEnabled(
      'vertragsbeginnMonthly',
    );
    if (!this.constraintsLoadFailed) {
      this.gueltigAbInfoText = this.translateService.instant(
        'TICKETDETAIL.ABO_GUELTIG_AB_INFO_KEIN_SCHULJAHR',
      ); //"Bitte erst ein Schuljahr wählen";
    }
  }

  getFieldLabelOrTranslate(fieldName: string, translateKey: string): string {
    return this.fieldConfigService.getFieldLabelOrTranslate(
      fieldName,
      this.fieldConfig,
      this.translateService.instant(translateKey),
      this.effectiveValidators,
    );
  }

  /**
   * Backend-computed: FieldConfigServiceDefault.getFieldConfigList() already ANDs the global
   * Sonderfall switch into extras.nachweisRequired per row
   * this is now the single source of truth, replacing the former client-side re-derivation.
   */
  getSonderfaelleRequiringNachweis(): string[] {
    return this.fieldConfigService
      .getFieldConfigFromSessionStorage([this.MODULE_ANTRAG_TICKET_SONDERFALL])
      .filter((fc) => fc.extras?.nachweisRequired)
      .map((fc) => fc.field);
  }

  getSonderfallOptionLabel(type: string, translateKey: string): string {
    return (
      '' +
      this.fieldConfigService.getFieldLabel(
        type,
        this.fieldConfig,
        translateKey ? this.translateService.instant(translateKey) : '',
      ) +
      ' ' +
      (this.getSonderfaelleRequiringNachweis().includes(type)
        ? MANDATORY_UPLOAD_MARKER
        : '')
    );
  }

  getTextbausteinOrTranslate(
    textbausteinKey: KeyString,
    translateKey: string,
  ): string {
    return this.existsSessionStorageTextbausteine
      ? this.textbausteinService.printTextbausteinByKey(
          textbausteinKey,
          translateKey ? this.translateService.instant(translateKey) : '',
        )
      : '';
  }

  filterAntragTicketSonderfallByFieldConfig() {
    // apply fieldConfig for Sonderfall options only if this is "fresh" Antrag
    // see: SFK2-1743
    // module_config.enabled['antragTicketSonderfall'] gate was removed (2026-08-20): it has no admin
    // toggle and no tenant can disable it, so field-config-driven filtering now always applies
    if (
      !this.optionSonderfall ||
      this.optionSonderfall.length === 0 ||
      (this.antragTicket?.id &&
        this.antragTicket?.status !== TicketAntragStatus.ENTWURF)
    )
      return;
    const fieldConfigAntragTicketSonderfallFields = this.fieldConfigService
      .getVisibleFieldsForModuleFromSessionStorage(
        this.MODULE_ANTRAG_TICKET_SONDERFALL,
      )
      .map((it) => it.field);
    this.optionSonderfall = this.optionSonderfall.filter(
      (it) =>
        !it.value || fieldConfigAntragTicketSonderfallFields.includes(it.value),
    );
  }

  /**
   * field_config(module='antragTicket', field='sonderfall').visible — the master on/off switch for
   * the whole Sonderfall feature (hides the entire Sonderfall section below, including per-type
   * Nachweis config). Distinct from `sonderfallEnabled` (applicant checkbox) and `sonderfallNachweis`
   * (upload-type visibility)
   */
  isSonderfallFeatureEnabled(): boolean {
    return (
      this.fieldConfigService.getFieldFromFieldConfig(
        this.FIELD_CONFIG_ANTRAG_TICKET_SONDERFALL_FEATURE_SWITCH,
        this.fieldConfig,
      )?.visible === true
    );
  }

  toggleVormundCheckbox(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.isVormundCheckboxChecked = inputElement.checked;
    this.toggleVormundByCheckbox();
  }

  loadExportConfig(): void {
    this.generalConfigService.getExportConfig().subscribe({
      next: (conf) => {
        this.exportConfig = conf;
      },
    });
  }

  loadAntragConfig(): void {
    this.generalConfigService.getAntragConfig().subscribe({
      next: (conf) => {
        this.allowedWegtypen = conf.allowedWegtypen;
        this.filterWegtypOptions();
      },
    });
  }

  loadEigenanteilConfig(): void {
    this.generalConfigService.getEigenanteilConfig().subscribe({
      next: (conf) => {
        this.geschwisterEigenanteilKomponenteEnabled =
          conf?.geschwisterEigenanteilKomponenteEnabled ?? true;
      },
      error: () => {
        this.geschwisterEigenanteilKomponenteEnabled = true;
      },
    });
  }

  protected readonly KeyString = KeyString;
  protected readonly AttachmentType = AttachmentType;
  protected readonly TicketAntragStatus = TicketAntragStatus;
  protected readonly PFLICHTFELDMARKER = PFLICHTFELDMARKER;
}
